import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
// react-bootstrap components
import {
  ListGroup,
  Tabs,
  Tab,
  Form,
  Modal,
  Card,
  Container,
  Row,
  Col,
  Table
} from "react-bootstrap";
import { Auth, Storage } from 'aws-amplify';
import { v4 as uuid } from "uuid";
import { groupBy as rowGrouper } from 'lodash';
import DataGrid from 'react-data-grid';
import { useLocation, useNavigate } from "react-router-dom";
import MultiSelect from "react-multiple-select-dropdown-lite";
import { useTour } from '@reactour/tour';
import moment from "moment/moment";
import 'moment-timezone';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select, { components as ReactSelectComponents } from 'react-select';
import * as XLSX from "xlsx";
import { Buffer } from "buffer";

import config from 'aws-exports';
import steps from "classic/steps";
import { logAudit, signOutUser, downloadS3Object, fetchMsg, fetchDocument, renderReactFragment, processUpload, isTemplateAllowed, cptood, extractDocument, notifyUser, checkUploadStatus, loadS3File, storageResultToBlob } from 'services/Helper';
import { doesFileExist, fetchJsonData, fetchSubmissionDocumentlist, fetchExcelFromS3, fetchJSONFromS3, fetchTransformationJSONData, getTemplateRules, getDocList, getSpFolderPath, compareQAFeedback, updateTransformationJSONData, fetchALLExcelSheetData, fetchTemplateList as fetchTemplateListData, resolveTemplateVersionFromData, handleUpdateSubmissionReport, isSendQaAsyncAcceptedResponse, notifyClientWithDetails, savedQALargeFileBackend } from '../components/Utils/ExtractUtils';
import { getQaDiffJsonPath } from '../components/Utils/qaFeedbackPaths';
import { getExtractedFileDisplayName, getExtractedFileDownloadName, getExtractedJsonDownloadName } from 'newui/components/Utils/extractedFileName';
import { resolveQaCompleteSendConfig } from 'newui/components/Utils/qaCompleteSendConfig';
import {
  SEND_QA_FAILURE_CODE,
  SEND_QA_FAILURE_STAGE,
  buildSendQaFailureNotice,
  persistBeforeQaCompleteDelivery
} from 'newui/components/Utils/sendQaFailureDetails';
import { getParameterFromManager, validateFileName } from "services/Utils";
import { initializeDateTimeZone, initializeDateFormat, formatDefaultDate} from "services/DateTimeUtils";
import { getMergedMeaValidationCheckRules, invokeLambdaWithRetry, invokeLambdaWithAPI } from "services/Helper";
import CirclesLoader from "../layouts/CirclesLoader";
import { RiCloseLine, RiPlayCircleLine } from "react-icons/ri";
import {
  canOpenClassicQaTool,
  resolveClassicUserRole,
} from "../../classicQaToolAccess";

//EXTRACTTOOL MARKER IMPORT START

//any imports exclusively used by extraction tool placed here
// import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { getDocDetails } from "../components/Utils/ExtractUtils";
import { BiSearch } from "react-icons/bi";
import { TiTick } from "react-icons/ti";
import { createUiLogger } from "../../logging/uiLogger";
import { updateDocument, updateSubmissionsReport } from '../components/Utils/qaStatusRequests';
import { useArchivedQaActions } from '../components/Utils/useArchivedQaActions';
const console = createUiLogger("meaplatform/classic/views/SubmissionsList.js");



//EXTRACTTOOL MARKER IMPORT END

const QATool = lazy(() => import('classic/components/Utils/QATool'));
const ReactPayPal = lazy(() => import('classic/components/PayPal/ReactPayPal'));
const DiffViewer = lazy(() => import('classic/components/Utils/DiffViewer'));
const ExtractTool = lazy(() => import('classic/components/Utils/ExtractTool'));

var allowedExtensions = ".pdf,.odt,.doc,.docx,.rtf,.ppt,.pptx,.xls,.xlsx,.msg,.eml,.jpg,.jpeg,.png,.mp4,.zip";
var allowedSimpleExtensions = ".pdf,.odt,.doc,.docx,.rtf,.ppt,.pptx,.xls,.xlsx,.jpg,.jpeg,.png,.mp4";

const initialFormState = { documentName: '', documentFullPath: '', uploadDate: '', processingStatus: 'Uploaded', submittedby: '', uploadDocumentName: '', uploadDocumentFullPath: '', file: null, files: null, target: null }
const submissionIdentifierAllowedPattern = /^[A-Za-z0-9-]+(?:\s[A-Za-z0-9-]*)*$/;

function getSubmissionIdentifierError(value) {
  if (!value || value.trim().length === 0) return "";
  if (/^\s|\s$/.test(value)) {
    return "Invalid submission identifier. Please remove spaces at the beginning or end.";
  }
  if (!submissionIdentifierAllowedPattern.test(value)) {
    const invalidChars = [...new Set(value.match(/[^A-Za-z0-9 -]/g) || [])].slice(0, 5).join(" ");
    return `Invalid submission identifier. Please remove unsupported special characters${invalidChars ? `: ${invalidChars}` : ""}.`;
  }
  return "";
}

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    values = (
      <div className="d-flex-center pl-1">
        {values.length > 1 ? `${values.length} option selected`
        : values.length === 1 ? values[0].props.children : 'Select'}
      </div>
    );
  }
  return (
    <ReactSelectComponents.ValueContainer {...props}>
      {values}
      {input}
    </ReactSelectComponents.ValueContainer>
  );
}

function SubmissionsList({ submissionModal, setSubmissionModal }) {

  const { setSteps, isOpen, setIsOpen, setCurrentStep, currentStep, onClickClose } = useTour();
  let [declineCode, setDeclineCode] = React.useState([]);
  let [declineCodeOptions, setDeclineCodeOptions] = React.useState([]);
  let [enableTriage, setEnableTriage] = React.useState(false);
  const [documents, setDocuments] = useState([]);
  const [formData, setFormData] = useState(initialFormState);
  const [showModal, setShowModal] = React.useState(false);
  const [showModalYesNo, setShowModalYesNo] = React.useState(false);
  const [showModalCompleteOrReject, setShowModalCompleteOrReject] = React.useState(false);
  const [showManualMerge, setShowManualMerge] = React.useState(false);
  const [showModalSelectTemplate, setShowModalSelectTemplate] = React.useState(false);
  const [rejectionReasons, setRejectionReasons] = React.useState("");
  const [showModalList, setShowModalList] = React.useState(false);
  const [runValidations, setRunValidations] = React.useState(true);
  const [enableUserDataValidations, setEnableUserDataValidations] = React.useState(false);
  const [showModalListMsg, setShowModalListMsg] = React.useState([]);
  const [showModalMsg, setShowModalMsg] = React.useState("");
  const [showModalYesNoMsg, setShowModalYesNoMsg] = React.useState("");
  const [evtShowModalYesNo, setEvtShowModalYesNo] = React.useState();
  const [presignedDownloadModal, setPresignedDownloadModal] = useState({
    show: false,
    url: "",
    fileName: "",
    expiresAt: "",
  });
  const [presignedDownloadCopied, setPresignedDownloadCopied] = useState(false);
  const [showReviewModal, setShowReviewModal] = React.useState(false);
  const [showReviewModalMsg, setShowReviewModalMsg] = React.useState([]);
  const [missingMandatoryFields, setMissingMandatoryFields] = useState([]);
  const validationResolveRef = useRef(null);
  const [showMandatoryValidationModal, setShowMandatoryValidationModal] = useState(false);
  const [thresholdValidation, setThresholdValidation] = useState(false);
  const [documentObj, setDocumentObj] = React.useState({ document: { documentName: "" } });
  const [checkout, setCheckout] = React.useState(false);
  const [submissionIdentifier, setSubmissionIdentifier] = React.useState("");
  const [disableUpload, setDisableUpload] = React.useState(false); // by default disableUpload is set to true, only when set to true users will not be able to upload file
  const [expandedGroupIds, setExpandedGroupIds] = React.useState();
  const [paid, setPaid] = React.useState(false);
  const [launchQATool, setLaunchQATool] = useState(false);
  const [launchDiffViewer, setLaunchDiffViewer] = useState(false);
  let [submissionCount, setSubmissionCount] = useState(-1);
  let [currentPage, setCurrentPage] = useState(0);
  const pageInputRef = useRef(null);// create a ref for the pagination text field
  const countryCodesCacheRef = useRef({ value: undefined, ts: undefined });
  const declineCodesCacheRef = useRef({ value: undefined, ts: undefined });
  const userGroupsCacheRef = useRef({ value: undefined, ts: undefined });
  let [loading, setLoading] = useState(false);
  let [userRole, setUserRole] = React.useState("MEA_USERS");
  const [searchText, setSearchText] = React.useState("");
  const [searchType, setSearchType] = React.useState("SubmissionID");
  let [defaultProcStatus, setDefaultProcStatus] = React.useState([]);
  let [procStatus, setProcStatus] = React.useState(defaultProcStatus);
  let [lobCode, setLOBCode] = React.useState("All");
  let [lobCodeDisplay, setLOBCodeDisplay] = React.useState("All");
  let [lobCodeOptions, setLOBCodeOptions] = React.useState([]);
  let [searchMode, setSearchMode] = React.useState("Full");
  const [enableTemplate, setEnableTemplate] = React.useState(false);
  const [templateName, setTemplateName] = React.useState([]);
  const [reprocTemplateName, setReprocTemplateName] = React.useState("");
  const [usedTemplates, setUsedTemplates] = React.useState([]);
  const [templateOptions, setTemplateOptions] = React.useState([]);
  const [lobCodeValidationEnabled, setLobCodeValidationEnabled] = React.useState(false);
  let [currentData, setCurrentData] = React.useState([]);
  const [showTagWindow, setShowTagWindow] = React.useState(false);
  var [paymentEnabled, setPaymentEnabled] = React.useState(false);
  var [mcUploadExt, setMCUploadExt] = React.useState(".xls,.xlsx");
  const [tagInput, setTagInput] = React.useState();
  const [tagKey, setTagKey] = React.useState("");
  const [tagValue, setTagValue] = React.useState("");
  const [tagValueError, setTagValueError] = React.useState("");
  const [triageLane, setTriageLane] = React.useState("Green");
  const [tagsUpdated, setTagsUpdated] = React.useState(false);
  const [QAStatusOptions, setQAStatusOptions] = React.useState([]);
  const [templateEntityNamesData, setTemplateEntityNamesData] = useState([]);
  const [jsonEntityNamesData, setJsonEntityNamesData] = useState([]);
  const [xlType, setXlType] = useState("Generic");
  const [maxTemplateCount, setMaxTemplateCount] = useState(250);

  let [countryCode, setCountryCode] = useState("All")
  let [countryCodeDisplay, setCountryCodeDisplay] = useState("All");
  let [showCountryCodes, setShowCountryCodes] = React.useState(false);
  let [assocCtryCodeOptions, setAssocCtryCodeOptions] = React.useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [dataTour, setDataTour] = useState(false);
  const [rejectionReasonsList, setRejectionReasonsList] = React.useState([])

  const [durationInDays, setDurationInDays] = useState(15);
  const [displaySubHistFromDate, setDisplaySubHistFromDate] = useState(moment().subtract(durationInDays, "days").startOf("day").toDate());
  const [displaySubHistToDate, setDisplaySubHistToDate] = useState(moment().endOf("day").toDate());
  const [subHistFromDate, setSubHistFromDate] = useState('');
  const [subHistToDate, setSubHistToDate] = useState('');
  const isSearchEnabled = !!displaySubHistFromDate;
  const [qaToolDocs, setQaToolDocs] = useState();
  let submissionDocumentDatalist = [];
  let [searchBased, setSearchBased] = React.useState("");
  let [offsetValue, setOffsetValue] = React.useState();
  const [timeZoneOffset, setTimeZoneOffset] = React.useState();
  const [serverTimeZone, setServerTimeZone] = React.useState("");
  const [selectedGroup, setSelectedGroup] = useState('');
  const [userGroups, setUserGroups] = useState([]);
  const [userGroupsLoaded, setUserGroupsLoaded] = useState(false);
  const [showTourModal, setShowTourModal] = useState(false);
  const [enableSelectedTemplate, setEnableSelectedTemplate] = useState(false);
  const [showEntitiesMismatchModal, setShowEntitiesMismatchModal] = useState(false);
  const [submissionListDefaultView, setSubmissionListDefaultView] = useState("Collapsed");
  const [uploadDateDisplayMode, setUploadDateDisplayMode] = useState("dateOnly");
  const [tagAllowedPattern, setTagAllowedPattern] = useState(null); // null = use fallback, string = regex from MEA_VALIDATIONS_CHECK > tag_allowed_chars
  //EXTRACTTOOL MARKER STATE START

  const [templateControllerList, setTemplateControllerList] = useState();
  const [showArchived, setShowArchived] = useState(false);
  const [isArchived, setIsArchived] = useState(false);
  const archivedQaActions = useArchivedQaActions(isArchived);
  const [tabSelected, setTabSelected] = useState("home");
  const [isInUploadedStatus, setIsInUploadedStatus] = useState(false);
  const [tourNewSubmissionVisible, setTourNewSubmissionVisible] = useState(false);
  const [extractToolData, setExtractToolData] = useState(null);
  const [instanceDetails, setInstanceDetails] = useState({});

  //for the selected file name
  const [selectedFileName, setSelectedFileName] = useState("");
  //for the showClaimsUI
  const [showClaims, setshowClaims] = useState(false);
  const [tagsList, setTagsList] = React.useState([]);
  const [selectedTagData, setSelectedTagData] = React.useState({});
  const [selectedDateFormat, setSelectedDateFormat] = useState('');
  const [inputDateFormats, setInputDateFormats] = useState([]);
  //pagination
  let [lobPageSize] = React.useState(20); // pageSize
  let [lobCurrentPage, setLobCurrentPage] = React.useState(0); // rowStart
  let [hasMoreLobs, setHasMoreLobs] = React.useState(true); // hasMoreLobs
  const [defaultRules, setDefaultRules] = useState({});
  // for batch processing
  const [showConsolidatedPopup, setShowConsolidatedPopup] = useState(false);
  const [isConsolidatedChecked, setIsConsolidatedChecked] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  //EXTRACTTOOL MARKER STATE END

  const selectRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const pageSize = 25;
  const showMissingGroupState = userGroupsLoaded && userGroups.length === 0;
  const procStatusOptions = [
    "Uploaded",
    "In Progress",
    "Complete",
    "Rejected",
    "QA Uploaded",
    "QA In Progress",
    "QA Complete"
  ];

  const QAProcStatusOptions = [
    "Uploaded",
    "In Progress",
    "Complete",
    "Rejected"
  ];

  useEffect(() => {
    async function getLobAndCcode() {
      const lobCode = await getParameterFromManager("LOB_CODES_VALIDATION");
      const countryCode = await getParameterFromManager("ENABLE_COUNTRY_CODE_VALIDATION");
      setLobCodeValidationEnabled(lobCode);
      setShowCountryCodes(countryCode);
    }
    getLobAndCcode();
  }, [templateOptions]);

  useEffect(() => {
    const initializeDateConfig = async () => {
      await Promise.all([
        initializeDateTimeZone(),
        initializeDateFormat(),
      ]);
    };

    initializeDateConfig();
  }, []);

  let useNewQAToolOrLegacy = {
    showQaOptions: true
  };

  async function getShowQAValue() {
    let templateJsonData = await fetchJSONFromS3('templates/rules/default_rules.json');
    if (templateJsonData !== false && Object.keys(defaultRules).length === 0) {
      setDefaultRules(templateJsonData);
    }
    let showQaOptions = ((templateJsonData?.metaData?.showQaOptions === undefined) || (templateJsonData?.metaData?.showQaOptions === true)) ? true : false;
    useNewQAToolOrLegacy['showQaOptions'] = showQaOptions;
  }

  useEffect(() => {
    const match = isDirectQATool();
    if (!match) {
      getShowQAValue();
    }
  }, [])

  useEffect(() => {
    if (documents.length > 0) {
      if (submissionListDefaultView.toLowerCase() === 'expanded') {
        const allGroupIds = new Set(documents.map(doc => doc.submissionIdentifier));
        setExpandedGroupIds(allGroupIds);
      } else {
        setExpandedGroupIds(undefined);
      }
    }
  }, [documents]);

  useEffect(() => {
    const match = isDirectQATool();
    if (match) {
      (async function navToQATool() {
        const { submissionIdentifier, templateName, documentName } = match;
        console.info(`Loading submissionIdentifier: ${submissionIdentifier}`);
        await setupUserRole();
        let docs = await getDocList({submissionIdentifier: submissionIdentifier});
        const decodedTemplate = templateName
          ? decodeURIComponent(templateName)
          : undefined;
        const decodedDoc = documentName
          ? decodeURIComponent(documentName)
          : undefined;
        if (!docs || docs.length === 0) {
          setShowModalMsg(`Submission Identifier ${submissionIdentifier} with template ${decodedTemplate} is not found.\n Please verify the submission identifier associated with this template exists in submissions list.`);
          setShowModal(true);
          navigate("/user/submissions/");
          initF();
          return; 
        }
        let docRow = null;
        if (templateName && documentName) {
          docRow = docs.find(item =>
            item.templateName === decodedTemplate &&
            item.documentName === decodedDoc
          );

          if (!docRow) {
            console.warn("Document not found");
            setShowModalMsg(`Document ${decodedDoc} with template ${decodedTemplate} is not found.\n Please verify the document associated with this template exists in submissions list.`);
            setShowModal(true);
            const fallbackSearch = submissionIdentifier;
            const fallbackStatuses = [
              "Uploaded",
              "In Progress",
              "Complete",
              "Rejected"
            ];
            searchMode = "Filtered";
            setSearchMode("Filtered");
            setSearchText(fallbackSearch);
            setProcStatus(fallbackStatuses);
            setCurrentPage(0);
            navigate("/user/submissions/");
            initF(true, {
              procStatusExplicit: fallbackStatuses,
              fallbackSearch,
            });
            return;
          }
        } else {
          let msg = docs.length === 1 ? docs : docs.filter(item => item.isMerged === 1);
          if (msg && msg.length === 1) {
            docRow = msg[0];
          }
        }
        // var msg = await fetchMergeRecord(submissionIdentifier);
        let row = docRow;
        let openedQATool = false;
        if (canOpenClassicQaTool(userRole, row)) {
          invokeNewQATool(row, isArchived);
          initF(false)
          openedQATool = true;
        } else {
          console.warn(
            row
              ? `invalid action on submissionIdentifier: ${submissionIdentifier}`
              : `no merge record for submissionIdentifier: ${submissionIdentifier}`,
          );
        }
        navigate("/user/submissions/");
        if (!openedQATool) {
          initF();
        }
      })();
      return;
    }
    var procStatusExplicit = "";
    if (!match && location.state && location.state.procStatus !== "") {
        setProcStatus(location.state.procStatus);
        setSearchMode("Filtered");
        procStatusExplicit = location.state.procStatus;
        location.state.procStatus = "";
    }
    async function initF(showPageLoader = true, initialFilters = {}) {
        if (showPageLoader) {
        setLoading(true);
        }
        const timeZoneList = await getParameterFromManager("MEA_TIMEZONE");
        setServerTimeZone(timeZoneList.serverTimeZone);
        setSearchBased(`${timeZoneList.serverTimeZone} - Default`);
        setTimeZoneOffset(timeZoneList);
        checkDayLightMode();

        const pymtEnabled = await getParameterFromManager("ENABLE_PAYMENT");
        setPaymentEnabled(pymtEnabled);
        
        const enableCCVal = await getParameterFromManager("ENABLE_COUNTRY_CODE_VALIDATION");
        setShowCountryCodes(enableCCVal);

        //for the SHOW_CLAIMS_UI 
        const showClaimsPS = await getParameterFromManager("SHOW_CLAIMS_UI");
        setshowClaims(showClaimsPS);

        let enableQA = false;
        let templateJsonData = await fetchJSONFromS3('templates/rules/default_rules.json');
        if (templateJsonData !== false && Object.keys(defaultRules).length === 0) {
          setDefaultRules(templateJsonData);
        }
        enableQA = ((templateJsonData?.metaData?.showQaOptions === undefined) || (templateJsonData?.metaData?.showQaOptions === true)) ? true : false;
        let defaultQAStatusOptions = [];
        if (enableQA === true) {
          setQAStatusOptions(procStatusOptions)
          defaultQAStatusOptions = procStatusOptions;
          let updateColumns = getColumns(true, isArchived)
          setColumns([...updateColumns])
        } else {
          let newArr = [];
          columns.forEach(i => {
            if (i.key !== "qaFileName") {
              newArr.push(i)
            }
            setColumns(newArr)
            setQAStatusOptions(QAProcStatusOptions)
            defaultQAStatusOptions = QAProcStatusOptions;
          })
        }

        const enableTour = await getParameterFromManager("ENABLE_TOUR");
        setDataTour(enableTour);

        const enableUserDataValidation = await getParameterFromManager("ENABLE_USER_DATAVALIDATIONS");
        setEnableUserDataValidations(enableUserDataValidation);

        const enableTriage = await getParameterFromManager("ENABLE_TRIAGE");
        setEnableTriage(enableTriage);

        await fetchTagsValues();

        const uploadStatus = await checkUploadStatus();
        setDisableUpload(uploadStatus);

        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        var domain = user.attributes.email.split("@")[1].toLowerCase();

        var meaValidationsCheck = await getParameterFromManager(`MEA_VALIDATIONS_CHECK`);
        if (meaValidationsCheck === null) return;
        meaValidationsCheck = getMergedMeaValidationCheckRules(meaValidationsCheck, meaValidationsCheck[domain] === undefined ? "default" : domain);
        if (meaValidationsCheck?.filetypes_supported !== undefined) {
          allowedExtensions = meaValidationsCheck?.filetypes_supported;
          const compoundExt = ".eml,.msg,.zip";
          allowedSimpleExtensions = allowedExtensions
            .split(",")
            .map(e => e.trim())
            .filter(e => !compoundExt.split(",").includes(e))
            .join(",");
        }
        if (meaValidationsCheck?.supported_filetype_to_markcomplete !== undefined) {
          setMCUploadExt(meaValidationsCheck?.supported_filetype_to_markcomplete);
        }
        const newDurationInDays = parseInt(meaValidationsCheck?.submission_from_to_date_duration ?? "15", 10);
        setDurationInDays(newDurationInDays);
        let initialFromDate = moment().subtract(newDurationInDays, "days").startOf("day").toDate()
        setDisplaySubHistFromDate(initialFromDate);

        let submissionStatusDefault = [];
        if (meaValidationsCheck.defaultSubmissionStatus && meaValidationsCheck.defaultSubmissionStatus.length > 0) {
          let statusList = meaValidationsCheck.defaultSubmissionStatus.filter(status => typeof status === 'string').map(status => status.trim().replace(/\b\w/g, char => char.toUpperCase()).replace(/\bQa\b/g, "QA")).filter(status => procStatusOptions.includes(status));
          let defaultStatus = defaultQAStatusOptions.length === statusList.length ? ["All", ...statusList] : statusList
          setProcStatus(defaultStatus);
          setDefaultProcStatus(statusList);
          submissionStatusDefault = statusList;
        } else {
          setProcStatus(["All", ...defaultQAStatusOptions]);
          setDefaultProcStatus(["All", ...defaultQAStatusOptions]);
          submissionStatusDefault = ["All", ...defaultQAStatusOptions];
        }
        if (initialFilters.procStatusExplicit) {
          setProcStatus(initialFilters.procStatusExplicit);
        }

        if (meaValidationsCheck?.submission_list_default_view !== undefined) {
          setSubmissionListDefaultView(meaValidationsCheck.submission_list_default_view);
        }

        let upload_date_display_mode;
        if (meaValidationsCheck?.upload_date_display_mode !== undefined) {
          upload_date_display_mode = meaValidationsCheck.upload_date_display_mode;
          setUploadDateDisplayMode(upload_date_display_mode);
        }

        if (meaValidationsCheck?.tag_allowed_chars) {
          setTagAllowedPattern(meaValidationsCheck.tag_allowed_chars);
        }

        await fetchDocuments(
          true,
          initialFilters.procStatusExplicit ?? procStatusExplicit,
          "",
          initialFromDate,
          undefined,
          false,
          submissionStatusDefault,
          upload_date_display_mode,
          initialFilters.fallbackSearch,
        );
        if (showPageLoader) {
        setLoading(false);
        }

        getBuildInfo();

        const [templatesResp, userGrps, lobCodeOptionsResp, countryCodesResp, declCodeOptionsResp] = await Promise.all([
          fetchTemplateList(),
          fetchUserGroups(),
          fetchLOBCodeList(),
          fetchCountryCodes(),
          fetchDeclineCodeList(),
        ]);

        const templates = templatesResp ?? [];
        for (var i = 0; i < templates.length; i++) {
          if (templates[i].TemplateName.toLowerCase() === 'default template') {
            setTemplateName([{ value: templates[i].TemplateName, label: templates[i].TemplateName }]);
            break;
          }
        }
        setTemplateOptions(templates);
        setUserGroups(userGrps);
        setSelectedGroup(userGrps?.[0]?.group_id || '');

        const hasDefaultLOBCode = userGrps?.some(item => item?.LOBCode?.toLowerCase() === "default");
        let filteredLobCodeOptions = lobCodeOptionsResp;
        if (!hasDefaultLOBCode) {
          const lobCodesToFilter = new Set(userGrps?.map(item => item?.LOBCode));
          filteredLobCodeOptions = filteredLobCodeOptions.filter(item => lobCodesToFilter.has(item?.LOBCode));
        }
        setLOBCodeOptions(filteredLobCodeOptions);

        let countryCodes = (countryCodesResp ?? []).map(obj => ({ label: `${obj.countryCode} - ${obj.country}`, value: obj.countryCode }));
        const hasDefaultCCCode = userGrps?.some(item => item?.CountryCode?.toLowerCase() === "default");
        let filteredCountryCodeOptions = countryCodes;
        if (!hasDefaultCCCode) {
          const CountryCodesToFilter = new Set(userGrps?.map(item => item?.CountryCode));
          filteredCountryCodeOptions = filteredCountryCodeOptions.filter(item => CountryCodesToFilter.has(item?.value));
        }
        setAssocCtryCodeOptions(filteredCountryCodeOptions);

        const declCodeOptions = (declCodeOptionsResp ?? []).map((data) => ({
          ...data,
          label: data.DeclinedReason,
          value: data.DeclineCode,
        }));
        setDeclineCodeOptions(declCodeOptions);
      }

    if(!match){
     initF();
    }
  }, []);


  useEffect(() => {
    checkDayLightMode();
  }, [subHistFromDate, subHistToDate]);

  useEffect(() => {
    (async function init() {
      if (!loading) {
        let checkLastAccess = await localStorage.getItem("lastAccessed");
        if (checkLastAccess === "null") {
          setShowTourModal(true);
        }
      }
    })();
  }, [loading]);

  //for the SHOW_CLAIMS_UI 
  useEffect(() => {
    if (showClaims) {
      steps.submissions.forEach(submission => {
        submission.content = submission.content.replace(/submission/g, "claim");
      });
    } else {
      steps.submissions.forEach(submission => {
        submission.content = submission.content.replace(/claim/g, "submission");
      });
    }
  }, [showClaims]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (showSuggestions && !e.target.classList.contains('suggestions') && e.target.tagName !== 'LI') {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [showSuggestions]);

  const getBuildInfo = async () => {
    const envDetails = await getParameterFromManager("ENVIRONMENT_DETAILS");
    let backendName = config.aws_user_files_s3_bucket.split('-');
    setInstanceDetails({
      instanceRegion: config.aws_project_region,
      instanceBucket: config.aws_user_files_s3_bucket,
      instanceBackend: backendName[1],
      instanceName: envDetails?.instance_name
    })
    return {
      instanceRegion: config.aws_project_region,
      instanceBucket: config.aws_user_files_s3_bucket,
      instanceBackend: backendName[1],
      instanceName: envDetails?.instance_name
    }; 
  }

  async function invokeQATool(row) {
    row = await archivedQaActions.resolve(row);
    setFormData(initialFormState);
    setDocumentObj({ document: row });
    if (row?.archivedQa) { setExtractToolData(row); return; }
    let getDocumentListResult = await submissionDocumentDatalist.filter(item => item?.submissionIdentifier === row?.submissionIdentifier);
    setQaToolDocs(getDocumentListResult);
    setLaunchQATool(true);
    genQAAudit(row);
    let templateController = await getParameterFromManager("TEMPLATE_CONTROLLER");
    setTemplateControllerList(templateController?.qaTool);
  }

  async function invokeNewQATool(row) {
    row = await archivedQaActions.resolve(row);
    setFormData(initialFormState);
    setDocumentObj({ document: row });
    setExtractToolData(row);
  }

  async function getDocDetailsList(document) {
    let dataRes = await getDocDetails(document, showArchived || isArchived || Boolean(document?.archivedQa));
    if (dataRes && dataRes?.response === false) {
      setShowModalMsg(`The instance does not support operations from Globalops`);
      setShowModal(true);
      // resumeFromFinish();
      return false;
    } else {
      return dataRes;
    }
  }
  
  //EXTRACTTOOL MARKER CODE END

  function getSearchOptions() {
    const options = [{ label: showClaims ? "Claim" : "Submission", value: showClaims ? "ClaimID" : "SubmissionID" }, { label: "Document Name", value: "Document Name" }]
    return options;
  }

  function getColumns(QAToolAction = false, isArchived = false, upload_date_display_mode = uploadDateDisplayMode) {
    return [
      {
        key: 'submissionIdentifier', name: showClaims ? 'Claim Identifier' : 'Submission Identifier', minWidth: 250, headerRenderer({ column }) {
          var fragMent = <React.Fragment>
            <div className="first-title" data-tour="step-8">
              {column.name}
            </div>
          </React.Fragment>;
          return fragMent;
        }
      },
      {
        key: 'documentName', name: 'Source File Name', formatter({ row }) {

          let docValues = submissionDocumentDatalist.find(item =>
            row?.documentName === item?.documentName && row.submissionIdentifier === item?.submissionIdentifier
          )
          if (docValues === undefined) {
            submissionDocumentDatalist.push(row)
          }
          function renderDownload() {
            return (
              <a href="/#" onClick={(e) => {
                downloadDocuments(e, row, "source", (row.isMerged >= 1) ? `${row.submissionIdentifier}-${row.templateName ?? ""}.pdf` : row.documentName);
              }}>
                {(row.isMerged >= 1) ? `${row.submissionIdentifier}-${row.templateName ?? ""}` : row.documentName}
              </a>
            );
          }

          function renderDocument() {
            return (
              <React.Fragment>
                {(row.isMerged >= 1) ? `${row.submissionIdentifier}-${row.templateName ?? ""}` : row.documentName}
              </React.Fragment>
            );
          }
          var fragMent = <React.Fragment>
            {
              row.processingStatus !== "Pending Upload" && userRole !== 'MEA_USERS' && userRole !== 'MEA_APIUSERS' && row.documentFullPath !== null
                ?
                (row.isMerged >= 1 && userRole === 'MEA_CORPORATE') ?
                  renderDocument()
                  :
                  renderDownload()
                :
                renderDocument()
            }
          </React.Fragment>
            ;
          return fragMent;
        },
        cellClass: `source-file-name-cell`,
      },
      { key: 'uploadDate', name: 'Uploaded Date', formatter({row}) {
        return upload_date_display_mode === 'dateAndTime' ? formatDefaultDate(row?.createDatetime, true, true) : formatDefaultDate(row?.uploadDate);
      }},
      { key: 'processingStatus', name: 'Processing Status', cellClass: `processing-status-cell`, },
      {
        key: 'uploadDocumentName', name: 'Extracted File Name', cellClass: `extracted-file-cell`, formatter({ row }) {
          var fragMent = <React.Fragment>
            {
              (
                (
                  (userRole === 'MEA_USERS' && row.paymentStatus === "Paid") ||
                  (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN')
                ) && (row.processingStatus === "Complete" || row.processingStatus === "In Progress" ||
                  row.processingStatus === "QA Uploaded" || row.processingStatus === "QA Complete" ||
                  row.processingStatus === "QA In Progress")
              ) ||
                (
                  (userRole === 'MEA_CORPORATE')
                  && (row.processingStatus === "Complete" ||
                    row.processingStatus === "QA Uploaded" || row.processingStatus === "QA Complete" ||
                    row.processingStatus === "QA In Progress")
                )
                ?
                <React.Fragment>
                  <a href="/#" onClick={(e) => {
                    downloadDocuments(e, row, "extracted", getExtractedFileDownloadName(row.uploadDocumentName, row.isMerged));
                  }}>
                    {getExtractedFileDisplayName(row.uploadDocumentName, row.isMerged)}
                  </a>
                </React.Fragment>
                :
                <React.Fragment>
                  {getExtractedFileDisplayName(row.uploadDocumentName, row.isMerged)}
                </React.Fragment>
            }
          </React.Fragment>
            ;
          return fragMent;
        }
      },
      // Conditionally include the QA File Name column
      ...((defaultRules?.metaData?.showQaOptions === false || useNewQAToolOrLegacy?.showQaOptions === false) ? [] : [{
        key: 'qaFileName',
        name: 'QA File Name',
        cellClass: 'qa-filename-cell',
        formatter({ row }) {
          return (
            <a href="/#" onClick={(e) => {
              downloadDocuments(e, row, "qa");
            }}>
              {row.qaFileName}
            </a>
          );
        }
      }]),
      {
        key: 'Tags', name: 'Tags', formatter({ row }) {
          var fragMent = <React.Fragment>
            {row.Tags && row.Tags.map(item => (
              <React.Fragment>
                {item.key + " : " + item.value + ","}
              </React.Fragment>
            ))}
          </React.Fragment>;
          return fragMent;
        }
      },
      {
        key: 'Actions', name: 'Actions', minWidth: 200, formatter({ row }) {
          const [enableQA, setEnableQA] = useState(false);
          useEffect(() => {
            if ((((userRole === 'MEA_CORPORATE') || (userRole === 'MEA_ADMIN')) && (row.processingStatus === "Complete" || row.processingStatus === "QA In Progress" || row.processingStatus === "QA Uploaded" || row.processingStatus === "QA Complete") && QAToolAction) && row?.templateName) {
              getTemplateRules(row.templateName).then(rules => {
                if (rules?.metaData?.EnableQA === true || rules?.metaData?.EnableQA === undefined) {
                  setEnableQA(true);
                }
              }
              );
            }
          }, [row?.templateName]);
          var fragMent = <React.Fragment>
            {
              (userRole === 'MEA_USERS' || userRole === 'MEA_ADMIN') && paymentEnabled === true && row.paymentStatus !== "Paid" && row.processingStatus === "Complete" && checkout === false &&
              !isArchived && <button type="button" className="btn-action font-weight-medium" onClick={() => {
                setCheckout(true);
                setFormData(initialFormState);
                setDocumentObj({ document: row });
              }}><i className="fa fa-credit-card" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Pay"></i></button>
            }
            {!isArchived &&
              (
                (!isArchived &&
                  ((!(row.processingStatus === "Uploaded"
                    || row.processingStatus === "Rejected"
                    || row.processingStatus === "In Progress"
                    || row.processingStatus === "QA Uploaded"
                    || row.processingStatus === "QA In Progress"
                    || row.processingStatus === "QA Complete"))
                    || (row.processingStatus === "QA Uploaded" && userRole === 'MEA_CORPORATE'))
                )
              ) &&
              <button type="button" className="btn-action font-weight-medium new-extract-btn" onClick={async () => {
                setReprocTemplateName("");
                setFormData(initialFormState);
                setDocumentObj({ document: row });
                //for the document see what all templates are used and disable them
                var usedTemp = await getUsedTemplates(row.submissionIdentifier);
                const usedTempList = usedTemp.filter(item => item !== null && item === row.templateName);
                setUsedTemplates(usedTempList);
                var templates = await fetchTemplateList();
                var lobCode = row.submissionIdentifier.split("-")[0].toLowerCase();
                var newTemplateOptions = templates.map(a => a.TemplateName);
                newTemplateOptions = newTemplateOptions.filter((el) => (!usedTemp.includes(el) && (el.toLowerCase().startsWith(lobCode) || el.toLowerCase() === 'default template')));
                if (newTemplateOptions.length > 0) {
                  setReprocTemplateName(newTemplateOptions[0]);
                }
                setEvtShowModalYesNo({ "params": { "row": documentObj.document }, "option": "reproc-template" });
                setShowModalSelectTemplate(true);
              }}><i className="fa fa-mars-double" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="New Extract"></i></button>
            }
            {
              enableQA && (((userRole === 'MEA_CORPORATE') || (userRole === 'MEA_ADMIN')) && (row.processingStatus === "Complete" || row.processingStatus === "QA In Progress" || row.processingStatus === "QA Uploaded" || row.processingStatus === "QA Complete") && QAToolAction) &&
              <button type="button" id="newQATool" className="btn-action font-weight-medium" onClick={async () => {
                invokeNewQATool(row, isArchived);
              }}><i className="fa fa-shield-dog" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="New QA Tool"></i></button>
            }

            {!isArchived && row.processingStatus === "Rejected" &&
              <button type="button" className="btn-action font-weight-medium" onClick={async (e) => {
                let rejReason = row.rejectionReasons || 'No rejection reason found'
                if (row.rejectionReasons === "Invalid file name.") {
                  let fileAttachmentController = await getParameterFromManager("FILE_ATTACHMENT_CONTROLLER");
                  const unsupportedCharList = fileAttachmentController?.["unsupported-charlist"];
                  rejReason += ` File name should not contain " ${unsupportedCharList.join(", ")} "`;
                }
                e.preventDefault();
                setShowModalMsg(rejReason);
                setShowModal(true);
              }}><i className="fa fa-edit" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Review"></i></button>
            }

            {(!isArchived || archivedQaActions.enabled) && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && (row.processingStatus === "QA Uploaded") &&
              <button type="button" className="btn-action font-weight-medium" onClick={(e) => {
                setEvtShowModalYesNo({ "params": { "evt": e, "row": row }, "option": "start-qa" });
                setShowModalYesNoMsg(`Do you want to mark the selected ${row.documentName} as QA In Progress?`);
                setShowModalYesNo(true);
              }}><i className="fa fa-bullhorn" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Start QA"></i></button>
            }

            {(!isArchived || archivedQaActions.enabled) && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && (row.processingStatus === "QA Uploaded" || row.processingStatus === "QA In Progress" || row.processingStatus === "QA Complete") &&
              <button type="button" className="btn-action font-weight-medium view-qa-correction" onClick={async (e) => {
                setDocumentObj({ document: await archivedQaActions.resolve(row) });
                setLaunchDiffViewer(true);
              }}><i className="fa fa-check-square" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="View QA Correction"></i></button>
            }

            {(!isArchived || archivedQaActions.enabled) && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && (row.processingStatus === "QA In Progress") &&
              <button type="button" className="btn-action font-weight-medium" onClick={(e) => {
                setEvtShowModalYesNo({ "params": { "evt": e, "row": row }, "option": "complete-qa" });
                setShowModalYesNoMsg(`You are about to mark the selected ${row.documentName} as QA Completed. Do you want to continue?`);
                setShowModalYesNo(true);
              }}><i className="fa fa-stop-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Complete QA"></i></button>
            }
            {
              (row?.processingStatus === "Uploaded" || row?.processingStatus === "Pending Upload") && userRole === 'MEA_ADMIN' && <button type="button" id={`${row.submissionIdentifier}-finishBtn`} className="btn-action font-weight-medium" onClick={async (e) => {
                e.preventDefault();
                setTabSelected("profile");
                setIsInUploadedStatus(true);
                setDeclineCode([]);
                setTriageLane("Green");
                setFormData(initialFormState);
                setRunValidations(true);
                setShowModalCompleteOrReject(true);
                setDocumentObj({
                  document: row,
                });
                let submissionRejectionReasons = await getParameterFromManager(`SUBMISSION_REJECTION_REASONS`);
                setRejectionReasonsList(submissionRejectionReasons.sort(function (a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                }))
              }}><i className="fa fa-flag-checkered" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Finish"></i></button>
            }

            {!isArchived && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && row.processingStatus === "In Progress" &&
              <button type="button" id={`${row.submissionIdentifier}-finishBtn`} className="btn-action font-weight-medium" title={`${row.submissionIdentifier}-finishBtn`} onClick={async (e) => {
                e.preventDefault();
                setDeclineCode([]);
                setTriageLane("Green");
                setFormData(initialFormState);
                setRunValidations(true);
                setShowModalCompleteOrReject(true);
                setDocumentObj({
                  document: row,
                });
                let submissionRejectionReasons = await getParameterFromManager(`SUBMISSION_REJECTION_REASONS`);
                setRejectionReasonsList(submissionRejectionReasons.sort(function (a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                }))
                let fetchDoc = await getDocDetailsList(row);
                let templateRules = await getTemplateRules(fetchDoc?.templateName);
                const templateType = templateRules?.metaData?.templateType;

                let getInstanceDetails = { instanceRegion: instanceDetails.InstanceRegion, instanceBucket: instanceDetails.InstanceBucket};
                const getTransformData = await fetchTransformationJSONData(fetchDoc, getInstanceDetails);
                if (getTransformData === false) {
                  setXlType(templateType ? templateType : "Generic");
                  await updateTransformationJSONData(fetchDoc, undefined, {
                    inputFileType: templateType ? templateType : "Generic",
                    templateName: fetchDoc?.templateName
                  });
                } else {
                  setXlType(getTransformData.inputFileType);
                }
                if ((templateType && templateType?.toLowerCase() !== 'generic') || getTransformData?.inputFileType?.toLowerCase() === 'sov' || getTransformData?.inputFileType?.toLowerCase() === 'loss run') {
                  let sovOutputCfg = await getParameterFromManager(`SOV_OUTPUT_CFG`);
                  if (sovOutputCfg?.dateFormats?.length > 0) {
                    setInputDateFormats(sovOutputCfg?.dateFormats?.map(format => ({
                      value: format?.toUpperCase(),
                      label: format?.toUpperCase()
                    })));
                  }
                }
               
              }}><i className="fa fa-flag-checkered" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Finish"></i></button>
            }

            {!isArchived && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && (row.processingStatus === "Complete" || row.processingStatus === "Rejected") &&
              <button type="button" className="btn-action font-weight-medium" onClick={(e) => {
                setEvtShowModalYesNo({ "params": { "evt": e, "row": row }, "option": "reprocess" });
                setShowModalYesNoMsg(`You are about to reprocess the selected document ${row.uploadDocumentName}. This will overwrite the previous extracted file contents. Do you want to continue?`);
                setShowModalYesNo(true);
              }}><i className="fa fa-retweet" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Reprocess"></i></button>
            }

            {!isArchived && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && ((row.processingStatus === "Uploaded" && row.allowRetry === 1) || (row.processingStatus === "In Progress" && row.allowRetry === 0)) &&
              <button type="button" className={`btn-action font-weight-medium retryBtn ${row.submissionIdentifier}-retryBtn`} onClick={async (e) => {
                setReprocTemplateName("");
                setFormData(initialFormState);
                setDocumentObj({ document: row });
                //for the document see what all templates are used and disable them
                var usedTemp = await getUsedTemplates(row.submissionIdentifier);
                const usedTempList = usedTemp.filter(item => item !== null && item === row.templateName);
                setUsedTemplates(usedTempList);
                var templates = await fetchTemplateList();
                var lobCode = row.submissionIdentifier.split("-")[0].toLowerCase();
                var newTemplateOptions = templates.map(a => a.TemplateName);
                newTemplateOptions = newTemplateOptions.filter((el) => (!usedTemp.includes(el) && (el.toLowerCase().startsWith(lobCode) || el.toLowerCase() === 'default template')));
                if (newTemplateOptions.length > 0) {
                  setReprocTemplateName(newTemplateOptions[0]);
                }
                setEvtShowModalYesNo({ "params": { "evt": e, "row": documentObj.document }, "option": "retry" });
                setShowModalSelectTemplate(true);
              }}

              ><i className="fa fa-redo" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Retry"></i></button>
            }

            {!isArchived && (userRole === 'MEA_ADMIN') &&
              <button type="button" className="btn-action font-weight-medium" onClick={(e) => {
                setEvtShowModalYesNo({ "params": { "evt": e, "row": row }, "option": "delete" });
                setShowModalYesNoMsg(`You are about to delete the document ${row.documentName}. Note that you CANNOT retrieve the original document and extracted file once deleted. Do you want to continue?`);
                setShowModalYesNo(true);
              }}><i className="fa fa-trash" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Delete"></i></button>
            }

            {!isArchived && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN' || userRole === 'MEA_CORPORATE') &&
              <button type="button" className="btn-action font-weight-medium" onClick={(e) => {
                setTagInput({ "params": { "row": row, "Tags": row.Tags } });
                setTagsUpdated(false);
                setShowTagWindow(true);
              }}><i className="fa fa-tags" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Tags"></i></button>
            }

            {
              ((!(row.processingStatus === "Pending Upload" || row.processingStatus === "Uploaded" || row.processingStatus === "In Progress" || row.processingStatus === "Rejected"))) &&
              <button type="button" className="btn-action font-weight-medium download-json" onClick={async () => {
                setLoading(true);
                try {
                  const batchStatus = (row?.batchProcessingStatus || "").toLowerCase();
                  if (batchStatus === "complete") {
                    let hasConsolidatedJson = false;
                    if (row?.uploadDocumentFullPath && row?.submissionIdentifier) {
                      const docPath = row.uploadDocumentFullPath.substring(0, row.uploadDocumentFullPath.lastIndexOf("/") + 1);
                      const batchClientFormatJsonPath = `${docPath}${row.submissionIdentifier}_extracted_batch.json`;
                      hasConsolidatedJson = await doesFileExist(batchClientFormatJsonPath);
                    }
                    if (hasConsolidatedJson) {
                      setSelectedRow(row);
                      setIsConsolidatedChecked(false);
                      setShowConsolidatedPopup(true);
                      return;
                    }
                  }
                  let s3Path = await getTrfFile(row.jsonExtractpath, row.jsonExtractOriginalpath, row.submissionIdentifier, row.document_id, row.uploadDocumentFullPath);
                  if (!s3Path || !s3Path.path || s3Path.path.trim() === "") {
                    setShowModalMsg("JSON file is not available for download.");
                    setShowModal(true);
                    return;
                  }
                  s3Path = s3Path.path;
                  await downloadS3Object(s3Path, getExtractedJsonDownloadName(row));
                } catch (err) {
                  console.error('err: ', err);
                  setShowModalMsg("JSON file is not available for download.");
                  setShowModal(true);
                } finally {
                  setLoading(false);
                }
              }}><i className="fa fa-code" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Download JSON"></i></button>
            }

          </React.Fragment>;
          return fragMent;
        },
        groupFormatter({ childRows }) {
          var fragMent = <React.Fragment>
            {
              !isArchived && (userRole === 'MEA_PROCESSORS' || userRole === 'MEA_ADMIN') && (childRows.length > 1) && requireManualMerge(childRows) &&
              <button type="button" className="btn-action font-weight-medium" onClick={() => {
                var mergeFileRowCreated = false;
                var docRow = undefined;
                for (var i = 0; i < childRows.length; i++) {
                  if (childRows[i].documentName.toLowerCase().endsWith("_merged.pdf") === true) {
                    mergeFileRowCreated = true;
                    if (childRows[i].processingStatus === "In Progress") {
                      docRow = childRows[i];
                    }
                  }
                }
                if (mergeFileRowCreated === true) {
                  setFormData(initialFormState);
                  setShowManualMerge(true);
                  setDocumentObj({
                    document: docRow,
                  });
                } else {
                  mergeDocument(childRows[0].submissionIdentifier);
                }
              }}><i className="fa fa-compass" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Create Merge File"></i></button>
            }
          </React.Fragment>;
          return fragMent;
        },
        headerRenderer({ column }) {
          var fragMent = <React.Fragment>
            <div data-tour="step-9" className="actions-heading">
              {column.name}
            </div>
          </React.Fragment>;
          return fragMent;
        }
      }
    ]
  }

  let [columns, setColumns] = React.useState(getColumns());

  function isCacheValid(cacheValTs) {
    if (cacheValTs === undefined) {
      return false;
    }
    const now = new Date();
    const msBetweenDates = Math.abs(cacheValTs.getTime() - now.getTime());
    const secBetweenDates = msBetweenDates / 1000;
    if (secBetweenDates > 300) {
      return false;
    }
    return true;
  }

  async function fetchDeclineCodeList() {
    try {
      const cache = declineCodesCacheRef.current;
      if (cache.value === undefined || (isCacheValid(cache.ts) === false)) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          "access_token": user.signInUserSession.idToken.jwtToken,
          "target": "listTriageDeclinedReasons"
        };
        const init = {
          body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        cache.ts = new Date();
        cache.value = data.response;
        return cache.value;
      } else {
        return cache.value;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function fetchUserGroups() {
    try {
      const cache = userGroupsCacheRef.current;
      if (cache.value === undefined || (isCacheValid(cache.ts) === false)) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          "access_token": user.signInUserSession.idToken.jwtToken,
          "target": "fetchUserGroups"
        };
        const init = {
          body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        cache.value = Array.isArray(data?.response?.data?.listUserGroupDetails)
          ? data.response.data.listUserGroupDetails
          : [];
        cache.ts = new Date();
        setUserGroups(cache.value);
        setUserGroupsLoaded(true);
        return cache.value;
      } else {
        setUserGroups(cache.value);
        setUserGroupsLoaded(true);
        return cache.value;
      }
    } catch (err) {
      console.error(err);
      setUserGroups([]);
      setUserGroupsLoaded(true);
      return [];
    }
  }

  async function genQAAudit(row) {
    var document = row;
    if (document.document_id !== undefined) {
      if (document.qaToolOpenCount === undefined || document.qaToolOpenCount === 0 || document.qaToolOpenCount === null) {
        logAudit(document.document_id, document.submissionIdentifier, "QA", "Open", "UI", "First Time", undefined).then((data) => { });
        const updDocument = {
          document_id: document.document_id,
          qaToolOpenCount: 1
        };
        try {
          await updateDocument(updDocument, document.archivedQa);
        } catch (err) {
          console.error(err);
        }
      }
    }
  }

  function requireManualMerge(childRows) {
    var showManualMergeBtn = true;
    for (var i = 0; i < childRows.length; i++) {
      if (childRows[i].documentName.toLowerCase().endsWith("_merged.pdf") === true) {
        if (childRows[i].processingStatus !== "In Progress") {
          showManualMergeBtn = false;
        }
      }
    }
    return showManualMergeBtn;
  }

  async function checkDayLightMode(event) {
    const result = timeZoneOffset?.timeZones.find((k) => {
      if (event === undefined) {
        return k === (searchBased === `${serverTimeZone} - Default` ? serverTimeZone : searchBased);
      } else {
        return k === (event === `${serverTimeZone} - Default` ? serverTimeZone : event);
      }
    })
    if (result) {
      const keyValue = result;
      const zoneResult = Object.entries(timeZoneOffset.tz_difference).find(([k, v]) => {
        return k === keyValue;
      });
      const [zoneKey, zoneName] = zoneResult;

      let formatDate = moment(displaySubHistFromDate).format("YYYY-MM-DD");
      var date = moment.tz(formatDate, zoneName);
      let isDST = date.isDST();

      let offset1Value = moment.tz(zoneName);
      let offset2Value = moment.tz(timeZoneOffset.tz_difference[serverTimeZone]);

      const offsetDifference = offset2Value.utcOffset() - offset1Value.utcOffset();
      let dstOffset = null;
      timeZoneOffset.daylight_saving.find((dstValue) => {
        if (!isDST && zoneKey === dstValue) {
          dstOffset = 60;
        } else {
          dstOffset = 0;
        }
        return "";
      })
      const timeDiffInMinutes = offsetDifference + dstOffset;
      setOffsetValue(timeDiffInMinutes);
    }
  }

  function isDirectQATool() {
    // Define a regular expression pattern to match the desired format
    const pattern = /^\/user\/submissions\/qatool\/([^/]+)(?:\/([^/]+)\/([^/]+))?$/;
    // Use the pattern to extract the identifier
    var pathname = location.pathname;
    if (localStorage.getItem("navigator") !== null) {
      pathname = localStorage.getItem("navigator");
      localStorage.removeItem("navigator");
    }
    const match = pathname.match(pattern);
    if (!match) return null;

    return {
      submissionIdentifier: decodeURIComponent(match[1]),
      templateName: match[2],
      documentName: match[3]
    };
  }

  async function fetchMergeRecord(submissionIdentifier) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "fetchMergeRecord",
        "submissionIdentifier": submissionIdentifier
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function fetchCountryCodes() {
    try {
      const cache = countryCodesCacheRef.current;
      if (cache.value === undefined || (isCacheValid(cache.ts) === false)) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          "access_token": user.signInUserSession.idToken.jwtToken,
          "target": "fetchCountryCodes"
        };
        const init = {
          body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        cache.ts = new Date();
        cache.value = data.response;
        return cache.value;
      } else {
        return cache.value;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function fetchLOBCodeList() {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const rowStart = lobCurrentPage * lobPageSize;
      console.debug(`fetchLOBCodeList body with rowStart: ${rowStart}, pageSize: ${lobPageSize}`);
      const body = {
        "target": "fetchLOBCodeList",
        "access_token": user.signInUserSession.idToken.jwtToken,
        "count": -1,
        rowStart,
        "pageSize": lobPageSize,
        "mode": "like"
      };
      const init = {
        body: JSON.stringify(body)
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLean", init);
      const isLastPage = data.lobCodes.length < lobPageSize || rowStart + data.lobCodes.length >= data.totalCount;
      if (isLastPage) setHasMoreLobs(false);
      // Append only unique items based on LOBCode & LineOfBusiness
      setLOBCodeOptions(prev => [
        ...prev,
        ...data.lobCodes.filter(newItem =>
          !prev.some(existingItem =>
            existingItem.LOBCode === newItem.LOBCode &&
            existingItem.LineOfBusiness === newItem.LineOfBusiness
          )
        )
      ]);
      return data.lobCodes;
    } catch (err) {
      console.error('err: ', err);
      return [];
    }
  }

  async function fetchTemplateList() {
    try {
      const templateController = await getParameterFromManager('TEMPLATE_CONTROLLER');
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "target": "fetchTemplateList",
        "access_token": user.signInUserSession.idToken.jwtToken,
        "count": -1,
        "rowStart": 0,
        "pageSize": templateController.maxTemplatesAllowed,
        "searchTemplate": "",
        "mode": "like"
      };
      const init = {
        body: JSON.stringify(body)
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLight", init);
      return data.templates;
      //console.log('dataPayload :>> ', dataPayload);
    } catch (err) {
      console.error('err: ', err);
      return [];
    }
  }

  async function resolveTemplateVersionNumber(templateName) {
    const normalizedTemplateName = templateName?.toString()?.trim()?.toLowerCase();
    if (!normalizedTemplateName) {
      return null;
    }
    if (normalizedTemplateName === "default template") {
      return null;
    }
    const hasVersionNumber = value =>
      value !== undefined && value !== null && value !== "";

    const templates = await fetchTemplateListData(undefined, maxTemplateCount, templateName);
    const matchedTemplate = templates?.find(template =>
      template?.TemplateName?.toString()?.trim()?.toLowerCase() === normalizedTemplateName
    );
    if (hasVersionNumber(matchedTemplate?.TemplateVersionNumber)) {
      return matchedTemplate.TemplateVersionNumber;
    }

    const existingTemplate = templateOptions.find(template =>
      template?.TemplateName?.toString()?.trim()?.toLowerCase() === normalizedTemplateName
    );
    return hasVersionNumber(existingTemplate?.TemplateVersionNumber)
      ? existingTemplate.TemplateVersionNumber
      : null;
  }

  async function getUsedTemplates(submissionIdentifier) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "getUsedTemplates",
        "submissionIdentifier": submissionIdentifier
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function onDocumentFinish(document, status) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      var msgresult = await fetchMsg(document.submissionIdentifier);
      var msgDoc = msgresult.data.listDocumentsAnyWithMsg;
      if (msgDoc.length === 1) {
        document.originalMsgFileName = msgDoc[0].documentName;
      }
      const body = {
        "target": "onDocumentFinish",
        "document": document,
        "status": status,
        "access_token": user.signInUserSession.idToken.jwtToken,
      };
      const init = {
        body: JSON.stringify(body)
      };
      await invokeLambdaWithRetry("instanceHandlerLight", init);
    } catch (err) {
      console.error('err: ', err);
    }
  }

  async function getTrfFile(jsonExtractpath, jsonExtractOriginalpath, submissionIdentifier, document_id, uploadDocumentFullPath, downloadClientDefined = false) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "target": "processDocument",
        "access_token": user.signInUserSession.idToken.jwtToken,
        "option": "get-trf",
        "jsonExtractpath": jsonExtractpath,
        "jsonExtractOriginalpath": jsonExtractOriginalpath,
        "submissionIdentifier": submissionIdentifier,
        "document_id": document_id,
        "uploadDocumentFullPath": uploadDocumentFullPath,
        "downloadClientDefined": downloadClientDefined === true
      };
      const init = {
        body: JSON.stringify(body)
      };
      const resp = await invokeLambdaWithRetry("instanceHandler", init);
      return resp;
    } catch (err) {
      console.error('err: ', err);
      return false;
    }
  }

  async function getSearchSuggestions(srchText) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      var body = {
        "target": "getSearchSuggestions",
        "access_token": user.signInUserSession.idToken.jwtToken,
        "searchText": srchText,
        "searchType": searchType,
        "procStatus": procStatus,
        "lobCode": lobCode,
        "fromDate": displaySubHistFromDate,
        "toDate": displaySubHistToDate
      };
      if (showArchived) {
        body["showArchived"] = showArchived;
      }
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLean", init);
      return data.options ? data?.options : [];
    } catch (err) {
      console.error('err: ', err);
      return [];
    }
  }

  async function setupUserRole() {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    const groups = user.signInUserSession.idToken.payload["cognito:groups"];
    const resolvedRole = resolveClassicUserRole(groups);
    if (resolvedRole === 'MEA_PROCESSORS') {
      userRole = 'MEA_PROCESSORS';
      setUserRole('MEA_PROCESSORS');
      if (columns[4].key === "paymentStatus") {//Remove Payment Status Column
        columns.splice(4, 1);
        setColumns(columns);
      }
    } else if (resolvedRole === 'MEA_ADMIN') {
      userRole = 'MEA_ADMIN';
      setUserRole('MEA_ADMIN');
      if (columns[columns.length - 2].key === "qaFileName") {
        columns.splice(columns.length - 1, 0, { key: 'qaFileProcessedBy', name: 'QA File Processed By' });
        columns.splice(columns.length - 1, 0, { key: 'qaFileProcessedDate', name: 'QA File Processed Date' });
        setColumns(columns);
      }
    } else if (resolvedRole === 'MEA_UNDERWRITER') {
      userRole = 'MEA_UNDERWRITER';
      setUserRole('MEA_UNDERWRITER');
      if (columns[4].key === "paymentStatus") {//Remove Payment Status Column
        columns.splice(4, 1);
        setColumns(columns);
      }
    } else if (resolvedRole === 'MEA_CORPORATE') {
      userRole = 'MEA_CORPORATE';
      setUserRole('MEA_CORPORATE');
      if (columns[4].key === "paymentStatus") {//Remove Payment Status Column
        columns.splice(4, 1);
        setColumns(columns);
      }
    }
  }

  function dbToJson(dbString) {
    if (!dbString) return [];
    const result = [];
    const regex = /{key=([^,]+), value=([^}]+)}/g;
    let match;
    while ((match = regex.exec(dbString)) !== null) {
        const key = match[1].trim();
        const value = match[2].trim();
        result.push({ key, value });
    }
    return result;
  }
    
  function jsonToDb(jsonArray) {
      if (!jsonArray || !Array.isArray(jsonArray) || jsonArray.length === 0) return '';

      const dbPairs = jsonArray.map(item => `{key=${item.key}, value=${item.value}}`);
      const result = dbPairs.join(', ');

      return result;
  }

  async function fetchDocuments(reloadPage, procStatusExplicit, noFilter, fromDate, showArchived, initialRowCount = false, submissionStatusDefault, upload_date_display_mode, fallbackSearch) {
    try {
      if (reloadPage === true) {
        submissionCount = -1;
        setSubmissionCount(-1);
      }
      await setupUserRole();
      var documents = await fetchDocumentList(procStatusExplicit, noFilter, fromDate, showArchived, initialRowCount, submissionStatusDefault, upload_date_display_mode, fallbackSearch);
      if (reloadPage === true) {
        setCurrentPage(0);
      }
      if (typeof documents !== "undefined" && documents !== null) {
        for (var i = 0; i < documents.length; i++) {
          if (documents[i].Tags !== null) {
            documents[i].Tags = dbToJson(documents[i].Tags);
          }
          if (documents[i].submissionIdentifier) {
            documents[i].submissionIdentifier = documents[i].submissionIdentifier?.toUpperCase();
          }
        }
        setDocuments(documents);
      } else if (documents === "undefined" || documents === null) {
        setDocuments([]);
      }
    } catch (err) {
      if (err === "The user is not authenticated") {
        signOutUser();
      }
      console.error(err);
    }
  }

  async function fetchDocumentList(procStatusExplicit, noFilter, fromDate, showArchived, initialRowCount, submissionStatusDefault, upload_date_display_mode, fallbackSearchText) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });

      let timezoneOffset = offsetValue !== undefined ? offsetValue : 0;
      const inputSubHistFromDate = new Date(fromDate || displaySubHistFromDate);
      const inputSubHistToDate = new Date(displaySubHistToDate);
      const localTimeZoneOffset = inputSubHistFromDate.getTimezoneOffset();
      const newSubHistFromDate = new Date(inputSubHistFromDate.getTime() + (timezoneOffset - localTimeZoneOffset) * 60 * 1000);
      const newSubHistToDate = new Date(inputSubHistToDate.getTime() + (timezoneOffset - localTimeZoneOffset) * 60 * 1000);
      const procStatusValues = submissionStatusDefault !== undefined ? submissionStatusDefault : procStatus.includes("All") ? defaultRules?.metaData?.showQaOptions === false ? procStatus: "All" : procStatus;
      var body = {
        "target": "fetchDocumentList",
        "access_token": user.signInUserSession.idToken.jwtToken,
        "count": submissionCount,
        "rowStart": initialRowCount ? 0 : currentPage * pageSize,
        "pageSize": pageSize,
        "searchText": ((noFilter === "nofilter") || (searchMode === "Full")) ? "" : (fallbackSearchText || searchText),
        "searchType": searchType,
        "procStatus": ((noFilter === "nofilter") || (searchMode === "Full")) ? procStatusValues : (procStatusExplicit === undefined || procStatusExplicit === "") ? procStatusValues : procStatusExplicit,
        "lobCodeFilter": ((noFilter === "nofilter") || (searchMode === "Full")) ? "All" : lobCode,
        "countryCodeFilter": ((noFilter === "nofilter") || (searchMode === "Full")) ? "All" : countryCode,
        "subHistFromDate": newSubHistFromDate,
        "subHistToDate": newSubHistToDate
      };
      if (showArchived) {
        body["showArchived"] = showArchived;
      }
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLean", init);
      if (submissionCount === -1 && data.count) {
        setSubmissionCount(data.count.rowcount);
      }
      if (showArchived) {
        setIsArchived(true);
        setColumns(getColumns(true, true, upload_date_display_mode));
      } else {
        setIsArchived(false);
        setColumns(getColumns(true, false, upload_date_display_mode));
      }
      return data.documents;
    } catch (err) {
      console.error('err: ', err);
      return false;
    }
  }

  async function fetchDocStatus(document) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "fetchMergeDocDetails",
        "document": document.document,
        "triageLane": triageLane,
        "declineCode": declineCode
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function getFileSizeLimit(domain) {
    if (domain === 'meaplatform.com') {
      return -1;
    }
    var meaValidationsCheck = await getParameterFromManager("MEA_VALIDATIONS_CHECK");
    meaValidationsCheck = getMergedMeaValidationCheckRules(meaValidationsCheck, meaValidationsCheck[domain] === undefined ? "default" : domain);
    if (meaValidationsCheck.maxfilesize_mb !== undefined) {
      return parseInt(meaValidationsCheck.maxfilesize_mb) * 1024 * 1024;
    }
    return -1;
  }

  // Function to refresh session only if the token has expired
  async function refreshSessionIfNeeded() {
    try {
      const session = await Auth.currentSession();
      const { exp } = session.getAccessToken().decodePayload();
      const currentTime = Math.floor(new Date().getTime() / 1000);
      if (exp < currentTime) { // Check if the token is already expired
        await Auth.currentAuthenticatedUser({ bypassCache: true });
      }
    } catch (err) {
      console.error("Error:- ", err);
    }
  }

  async function createDocuments(e) {
    e.preventDefault();
    let templateList = templateName?.map(list => list.value);
    let subId = submissionIdentifier.split("-").map(part => part.toLowerCase());
    if (lobCodeValidationEnabled === true && showCountryCodes === false) {
      templateList = templateList.map(template =>{
        const checkDefaultTemp = mapTemplateOptions().find((template) =>
          template.TemplateName.toLowerCase() === `${subId[0]}-default template` || template.TemplateName.toLowerCase() === `${subId[0]}-defaulttemplate`
        )
        if (template.toLowerCase() === "default template") {
          return checkDefaultTemp?.TemplateName
        } 
        return template;
      }).filter((template, index, self) => index === self.indexOf(template));
    } else if (lobCodeValidationEnabled === true && showCountryCodes === true) {
      templateList = templateList.map(template => {
        const checkDefaultTemp = mapTemplateOptions().find((template) =>
          template.TemplateName.toLowerCase() === `${subId[0]}-${subId[1]}-default template` || template.TemplateName.toLowerCase() === `${subId[0]}-${subId[1]}-defaulttemplate`
        )
        if (template.toLowerCase() === "default template") {
          return checkDefaultTemp?.TemplateName
        } 
        return template;
      }).filter((template, index, self) => index === self.indexOf(template));
    }
    
    try {
      setLoading(true);
      if ((!formData.documentName || !formData.documentFullPath || (formData.file === null)) && (formData.files === null))
        return;
      try {
        // Ensure the session is still valid, and refresh if needed
        await refreshSessionIfNeeded();
        var inputFiles = [];
        var documentFullPath;
        if (formData.files === null) {
          documentFullPath = `${submissionIdentifier}/${uuid()}/${uuid()}${formData.documentName}`;
          await Storage.put(documentFullPath, formData.file, {
            metadata: {
              source: "UI"
            }
          });
          await Storage.put(`info-staging/ui/${documentFullPath}`, '');
          inputFiles.push({ documentName: formData.documentName, documentFullPath: documentFullPath });
        } else {
          for (var i = 0; i < formData.files.length; i++) {
            documentFullPath = `${submissionIdentifier}/${uuid()}/${uuid()}${formData.files[i].name}`;
            await Storage.put(documentFullPath, formData.files[i], {
              metadata: {
                source: "UI"
              }
            });
            await Storage.put(`info-staging/ui/${documentFullPath}`, '');
            inputFiles.push({ documentName: formData.files[i].name, documentFullPath: documentFullPath });
          }
        }
        if (!templateList.some(item => item !== undefined)) {
          if (lobCodeValidationEnabled === true) {
            if(showCountryCodes === true){
              setShowModalMsg(` Default template for ${subId[0]?.toUpperCase()}-${subId[1]?.toUpperCase()} is not available, Please create the template for ${subId[0]?.toUpperCase()}-${subId[1]?.toUpperCase()} and upload.`);
            } else{
              setShowModalMsg(`Default template for ${subId[0]?.toUpperCase()} is not available, Please create the template for ${subId[0]?.toUpperCase()} and upload.`);
            }
          }
          setShowModal(true);
          setEnableTemplate(false);
          setSubmissionModal(false);
          setSubmissionIdentifier('');
          setSelectedFileName('');
          setEnableSelectedTemplate(false);
          return;
        }
        var result = await processUpload(submissionIdentifier, templateList, inputFiles, selectedGroup);
        if (result.disableUpload !== undefined) {
          setDisableUpload(result.disableUpload);
        }
        if (result.allow === false) {
          setShowModalMsg(result.message);
          setShowModal(true);
        }
       
        var docResult = await fetchSubmissionDocumentlist({submissionIdentifier: submissionIdentifier});
        const shouldBypassReprocessForUpload = Array.from(inputFiles || []).some(
          (file) =>
            ['.eml', '.msg', '.zip'].some((ext) =>
              String(file?.documentName || file?.name || file?.documentFullPath || '')
                .toLowerCase()
                .endsWith(ext)
            )
        );
        if (templateList?.length > 1 && !shouldBypassReprocessForUpload){
          for (let i = 1; i < templateList.length; i++) {
            docResult?.length > 0 && docResult?.forEach(async(list) => 
              await reprocessDocument(list, templateList[i])
            );
          }        
        }
      } catch (err) {
        if (err === "The user is not authenticated") {
          signOutUser();
        }
        else if (err?.message?.startsWith("The provided token has expired")) {
          // Attempt to refresh the session and retry
          await refreshSessionIfNeeded();
          await createDocuments(e); // Retry the operation
        }
        else {
          console.error('error: ', err);
        }
      }
      formData.target.value = null;
      setFormData(initialFormState);
      setDocuments([...documents, formData]);
      fetchDocuments(true);
      setEnableTemplate(false);
      setSubmissionModal(false);
      setSubmissionIdentifier('');
      setSelectedFileName('');
      setEnableSelectedTemplate(false);
    } finally {
      setLoading(false);
    }
  }

  async function retryDocument(document, reprocTemplateName) {
    try {
      setLoading(true);
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      var documentName = document.documentName;
      extractDocument(document, "newupload", undefined, undefined, true, document.compoundDocNumber !== undefined, reprocTemplateName);
      notifyUser({ "toAddress": user.attributes.email, "name": user.attributes.given_name, "fileName": documentName, "option": "newDocumentCreated", "submissionIdentifier": document.submissionIdentifier });
      logAudit(document.document_id, document.submissionIdentifier, "Submission", "Retry", "UI", undefined, undefined, reprocTemplateName, { isGlobalRecord: 1, documentName: document.documentName }).then((data) => { });
      setShowModalSelectTemplate(false);
      await fetchDocuments(true, undefined, undefined, undefined, isArchived);
    } finally {
      setLoading(false);
    }
  }

  async function receiveStrippedExtract(inpDocument, fPath, uploadDocumentFullPath, fileType) {
    try {
      setLoading(true);
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "stripped-extract",
        "submissionIdentifier": inpDocument.submissionIdentifier,
        "document_id": inpDocument.document_id,
        "fPath": fPath,
        "uploadDocumentFullPath": uploadDocumentFullPath,
        ...(fileType === 'qa' && { fileType: 'qa' })
      };
      const init = {
        body: body
      };
      await invokeLambdaWithRetry("instanceHandler", init);
    } finally {
      setLoading(false);
    }
  }

  function getPresignedUrlExpiry(url) {
    try {
      const params = new URL(url).searchParams;
      const signedAt = params.get("X-Amz-Date");
      const expiresIn = parseInt(params.get("X-Amz-Expires"), 10);

      if (!signedAt || !Number.isFinite(expiresIn)) {
        return "";
      }

      const match = signedAt.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/);
      if (!match) {
        return "";
      }

      const generatedAt = Date.UTC(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        Number(match[4]),
        Number(match[5]),
        Number(match[6])
      );

      return new Date(generatedAt + expiresIn * 1000).toLocaleString();
    } catch (err) {
      return "";
    }
  }

  async function shouldShowPresignedDownloadURL(document, fallbackRules = {}) {
    let templateRules = {};

    try {
      if (document?.templateName) {
        templateRules = await getTemplateRules(document.templateName);
      }
    } catch (err) {
      console.error("Error fetching template rules:", err);
    }

    const configuredValue =
      templateRules?.metaData?.showPresignedDownloadURL ??
      fallbackRules?.metaData?.showPresignedDownloadURL ??
      defaultRules?.metaData?.showPresignedDownloadURL;

    return configuredValue === true;
  }

  async function getPresignedDownloadURL(filePath, fileName) {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    const body = {
      access_token: user.signInUserSession.idToken.jwtToken,
      target: "fetchStorageDetails",
      document: {
        docPath: filePath,
        docFileName: fileName
      }
    };
    const init = {
      body: body
    };
    const data = await invokeLambdaWithRetry("instanceHandler", init);
    return data?.response;
  }

  function closePresignedDownloadModal() {
    setPresignedDownloadModal({
      show: false,
      url: "",
      fileName: "",
      expiresAt: "",
    });
    setPresignedDownloadCopied(false);
  }

  async function copyPresignedDownloadURL() {
    if (!presignedDownloadModal.url) {
      return;
    }

    try {
      await navigator.clipboard.writeText(presignedDownloadModal.url);
      setPresignedDownloadCopied(true);
      setTimeout(() => setPresignedDownloadCopied(false), 1500);
    } catch (err) {
      console.error("Error copying presigned download URL:", err);
      setShowModalMsg("Unable to copy the URL. Please select and copy it manually.");
      setShowModal(true);
    }
  }

  async function downloadDocuments(e, document, downloadType, fileName) {
    e.preventDefault();
    const templateController = await getParameterFromManager('TEMPLATE_CONTROLLER');
    var fPath = (downloadType === "extracted" ? document.uploadDocumentFullPath : (downloadType === "qa" ? document.qaFileFullPath : document.documentFullPath));
    let SOVJsonPath = `${document.documentFullPath.split('/')[0]}/DocumentsMeta/${document.document_id}.json`;
    let jsonS3DataRes,data;
    try {
      jsonS3DataRes = await Storage.get(SOVJsonPath, { download: true });
      let json_data = await (await storageResultToBlob(jsonS3DataRes)).text();
      data = JSON.parse(json_data);
    } catch (err) {
      //console.log("SOV Json not found");
    }
    let templateColumnRules = await fetchJSONFromS3(`templates/rules/${document.templateName}_rules.json`);
    let defaultColumnRules = await fetchJSONFromS3(`templates/rules/default_rules.json`);
    let templateType = templateColumnRules?.metaData?.templateType || defaultColumnRules?.metaData?.templateType;
    let isTemplateTypeSOV = templateType?.toString()?.toLowerCase() === 'sov' || templateType?.toString()?.toLowerCase() === 'loss run';
    if (
      templateController && (templateController.jsonDownloadColumns || templateController.jsonDontDownloadColumns) &&
      (downloadType === "extracted" || downloadType === "qa") &&
      (data ? (data.inputFileType.toLowerCase() === "generic") : !isTemplateTypeSOV)
    ) {
      fPath = replaceLastOfFile(fPath, "_stripped", "xlsx");
      var exists = await doesFileExist(fPath);
      if (exists !== true) {
        await receiveStrippedExtract(document, fPath, downloadType === "qa" ? document.qaFileFullPath : document.uploadDocumentFullPath, downloadType);
      }
    }    

    if (downloadType === "extracted" && document.downloadCount === 0) {
      const updDocument = {
        document_id: document.document_id,
        downloadCount: document.downloadCount + 1
      };
      try {
        await updateDocument(updDocument);
      } catch (err) {
        if (err === "The user is not authenticated") {
          signOutUser();
        }
        console.error(err);
      }
    }
    const finalDownloadName = downloadType === "extracted" ? fileName : (downloadType === "qa" ? document.qaFileName : fileName);

    if (await shouldShowPresignedDownloadURL(document, defaultColumnRules)) {
      try {
        const url = await getPresignedDownloadURL(fPath, finalDownloadName);
        if (!url) {
          setShowModalMsg("Download URL is not available.");
          setShowModal(true);
          return;
        }
        setPresignedDownloadModal({
          show: true,
          url,
          fileName: finalDownloadName,
          expiresAt: getPresignedUrlExpiry(url),
        });
      } catch (err) {
        console.error("Error generating presigned download URL:", err);
        setShowModalMsg("Unable to generate download URL.");
        setShowModal(true);
      }
      return;
    }

    await downloadS3Object(fPath, finalDownloadName);
  }

  async function updateDocumentTags(document_id, Tags) {
    try {
      setLoading(true);
      try {
        if (Tags !== null) {
          const updDocument = {
            document_id: document_id,
            Tags: Tags
          };
          const result = await updateDocument(updDocument);
          if (result?.error) {
            setShowModalMsg(result.errorDescription || 'Failed to save tags. Please try again.');
            setShowModal(true);
            return false;
          }
        } else {
          await clearDocumentTags(document_id);
        }
        await fetchDocuments(false);
        return true;
      } catch (err) {
        console.error(err);
        if (err === "The user is not authenticated") {
          signOutUser();
        }
        return false;
      }
    } finally {
      setLoading(false);
    }
  }

  async function reprocessDocument(inpDocument, templateName) {
    try {
      setLoading(true);
      var today = new Date();
      var nDate = today.toJSON().slice(0, 10);//YYYY-MM-DD
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "getLastMergedSeq",
        "submissionIdentifier": inpDocument.submissionIdentifier
      };
      const init = {
        body: body
      };
      let res = await invokeLambdaWithRetry("instanceHandler", init);
      var origInfo = await fetchDocument(inpDocument.origin_document_id);
      var document_id = uuid();
      let document = {
        document_id: document_id,
        submissionIdentifier: inpDocument.submissionIdentifier.toUpperCase(),
        documentName: inpDocument.documentName,
        documentFullPath: inpDocument.documentFullPath,
        uploadDate: nDate,
        processingStatus: 'Uploaded',
        submittedby: user.username,
        domainForDoc: origInfo.domainForDoc,
        downloadCount: 0,
        templateName: templateName,
        origin_document_id: inpDocument.origin_document_id,
        origin: origInfo.origin === "user-plain" ? "user-plain" : "merge",
        group_id: origInfo.group_id
      };
      const templateVersionNumber = await resolveTemplateVersionNumber(templateName);
      if (templateVersionNumber !== null) {
        document.TemplateVersionNumber = templateVersionNumber;
      }
      var filePathParts = inpDocument.documentFullPath.toLowerCase().split('.');
      if (allowedSimpleExtensions.split(',').map((i) => i.trim()).includes(`.${filePathParts[filePathParts.length - 1]}`) === false) {
        document.isMerged = res + 1;
      }
      var documentEscaped = { ...document };
      documentEscaped.submissionIdentifier = documentEscaped.submissionIdentifier.replace(/'/g, "''").replace(/"/g, "\\\"");
      documentEscaped.documentName = documentEscaped.documentName.replace(/'/g, "''").replace(/"/g, "\\\"");
      documentEscaped.documentFullPath = documentEscaped.documentFullPath.replace(/'/g, "''").replace(/"/g, "\\\"");
      res = await createDocument(documentEscaped);
      if (allowedSimpleExtensions.split(',').map((i) => i.trim()).includes(`.${filePathParts[filePathParts.length - 1]}`) === false) {
        extractDocument(document, "reproc-template", undefined, undefined, undefined, undefined, reprocTemplateName !== "" ? reprocTemplateName : templateName, origInfo.group_id);
      } else {
        extractDocument(document, "reproc-template-simple", undefined, undefined, undefined, undefined, reprocTemplateName !== "" ? reprocTemplateName : templateName, origInfo.group_id);
      }
      logAudit(document_id, documentEscaped.submissionIdentifier, "Submission", "Reprocess Template", "UI", undefined, undefined, undefined, { isGlobalRecord: 1, documentName: documentEscaped.documentName }).then((data) => { });
      await fetchDocuments(true, undefined, undefined, undefined, isArchived);
      setShowModalSelectTemplate(false);
    } finally {
      setLoading(false);
    }
  }

  async function uploadManualMergeDoc(e, document) {
    e.preventDefault();
    if (formData.file === null)
      return;
    try {
      setLoading(true);
      var newMergePath = getExtractPath(document.documentFullPath !== null ? document.documentFullPath : document.uploadDocumentFullPath);
      newMergePath = `${newMergePath}/${uuid()}${documentObj.document.documentName}`;
      //Upload this file into the S3 bucket for that Submission
      await Storage.put(newMergePath, formData.file, {
        metadata: {
          source: "UI",
          suffix: "_merged"
        }
      });
      await Storage.put(`info-staging/ui/${newMergePath}`, '');
      //Copy the merged file to the sharepoint under the submission id folder
      cptood(document.submissionIdentifier, newMergePath, documentObj.document.documentName);
      //Update the row for the submission id for the following columns
      const updDocument = {
        document_id: document.document_id,
        documentFullPath: newMergePath
      };
      await updateDocument(updDocument);
      setFormData(initialFormState);
      setShowManualMerge(false);
      await fetchDocuments(true, undefined, undefined, undefined, isArchived);
    } finally {
      setLoading(false);
    }
  }

  async function mergeDocument(submissionIdentifier) {
    setLoading(true);
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });

      console.info(`Invoking mergeDocument for ${submissionIdentifier}`);
      var body = {
        "target": "mergeDocuments",
        "submissionIdentifier": submissionIdentifier,
        "access_token": user.signInUserSession.idToken.jwtToken,
        "userName": user.username,
        "option": "merge-ready-files",
        "trigger": "user"
      };
      var msgresult = await fetchMsg(submissionIdentifier);
      var msgDoc = msgresult.data.listDocumentsAnyWithMsg;
      if (msgDoc.length === 1) {
        document.origin_document_id = msgDoc[0].document_id;
      }
      const init = {
        body: JSON.stringify(body)
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      console.info(`Invoked mergeDocument for ${submissionIdentifier} response: ${JSON.stringify(data)}`);// successful response
    } catch (err) {
      console.error('err: ', err);
      setLoading(false);
      setShowModalMsg("Error encountered while creating merge file, contact the support team");
      setShowModal(true);
      return false;
    }
    await fetchDocuments(true, undefined, undefined, undefined, isArchived);
    setLoading(false);
    setShowModalMsg("Merge file was successfully created, check the submission");
    setShowModal(true);
    return true;
  }

  async function runMacros(username, email, document, s3Path, access_token, post_process, uploadDocumentName, thresholdValidation) {
    try {
      //Store file to S3
      var macResponse = {};
      const body = {
        "target": "extractDocument",
        "access_token": access_token,
        "option": "macro_process",
        "post_process": post_process,
        "document_id": document.document_id,
        "inputfile": s3Path,
        "submissionIdentifier": document.submissionIdentifier,
        "templateName":document?.templateName,
        "inputname": uploadDocumentName,
        ...(selectedDateFormat && selectedDateFormat?.length > 0 ? { inputDateFormat: selectedDateFormat } : {}),
        ...(xlType && xlType?.length > 0 ? { inputFileType: xlType } : {}),
        "thresholdValidation": thresholdValidation
      };
      const init = {
        body: JSON.stringify(body)
      };
      let resp = await invokeLambdaWithRetry("instanceHandler", init);
      var bReturn = true;
      var msg = [];
      if (resp.status !== undefined && resp.status.length !== 0) {
        for (var m = 0; m < resp.status.length; m++) {
          msg.push(resp.status[m]);
          if (resp.status[m].code !== "altered") {
            bReturn = false;
          }
        }
        macResponse = { status: bReturn, outputfile: resp.outputfile, info: resp.info, msg: msg };
      } else if (resp.statusCode === 200) {
        macResponse = { status: true, outputfile: s3Path, info: resp.info };
      }
      //Show list of errors and warnings
      if (macResponse.status === true) {
        await doDocumentProcessing(username, email, document, "Complete", undefined, macResponse.outputfile, resp.info.producerName, resp.info.numFieldsExtracted, resp.info.insuredName, resp.info.brokerName, true);
      }
      return macResponse;
    } catch (err) {
      console.error('err: ', err);
      return { status: false };
    }
  }

  function replaceLastOfFile(fname, last, extension) {
    var fparts = fname.split(".");
    fparts[fparts.length - 2] += last;
    fparts[fparts.length - 1] = extension;
    return fparts.join(".");
  }





  async function createDocument(createDocumentsInput) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "createDocument",
        "createDocumentsInput": createDocumentsInput
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function clearDocumentTags(document_id) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "clearDocumentTags",
        "document_id": document_id
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function deleteDocument(document_id) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "deleteDocument",
        "document_id": document_id
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function extractExcelData(uploadDocumentFullPath, region, bucket) {
    const arrayBuffer = await fetchExcelFromS3(uploadDocumentFullPath, region, bucket);
    const workbook = XLSX.read(arrayBuffer);
    let jsonData;
    
    workbook.SheetNames.forEach(sheetName => {
      if (sheetName.toLowerCase() === "lookups") {
        return;
      }
      jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: null, raw: false });
    });
    return jsonData;
  }

  async function calculateSovMetrics(filePath) {
    try {
      if (!filePath) return null;
      const normalizedPath = filePath.replace(/^\/public\//i, "");
      const arrayBuffer = await fetchExcelFromS3(normalizedPath);
      if (!arrayBuffer) return null;

      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      let TotalRowCount = 0;
      let TotalColumnCount = 0;
      for (const sheetName of workbook.SheetNames) {
        if (
          sheetName.trim().toLowerCase().startsWith('summary detail') ||
          sheetName.trim().toLowerCase().startsWith('lookup')
        ) continue;
        const worksheet = workbook.Sheets[sheetName];
        const rows = new Set();
        let maxHeaderCol = -1;
        for (const cellAddress in worksheet) {
          if (cellAddress[0] === '!') continue;
          const cell = XLSX.utils.decode_cell(cellAddress);
          rows.add(cell.r);
          // Header row is first row (row index 0)
          if (cell.r === 0) {
            maxHeaderCol = Math.max(maxHeaderCol, cell.c);
          }
        }
        // Data records (excluding header)
        TotalRowCount += Math.max(0, rows.size - 1);
        // Columns based on header row
        TotalColumnCount += maxHeaderCol + 1;
      }

      return { TotalRowCount, TotalColumnCount };
    } catch (err) {
      console.error('calculateSovMetrics failed:', err);
      return null;
    }
  }

  async function getTemplateJson(document, region, bucket) {
    return await fetchJSONFromS3(document.jsonExtractpath, region, bucket);
  }

  const validateMandatorySummaryFields = async (
    instanceExcelDetails,
    summarySubmissionFileData,
    summarySheetName = "Summary Details",
  ) => {
    try {
      const worksheetData = await fetchALLExcelSheetData(
        instanceExcelDetails,
        summarySheetName
      );
      if (!worksheetData?.length || !worksheetData[0]?.length) {
        return [];
      }

      const rows = worksheetData[0];
      const submissionWorksheetData = await fetchALLExcelSheetData(
        instanceExcelDetails,
        "Submission"
      );

      const submissionRows = submissionWorksheetData?.[0] || [];
      const submissionHeader = submissionRows[0] || [];
      const entityNameColumnIndex = submissionHeader.findIndex(
        cell =>
          cell?.value?.toString()?.trim()?.toLowerCase() === "entity name"
      );

      if (entityNameColumnIndex === -1) return [];

      const submissionEntityNames = new Set(
        submissionRows
          .slice(1)
          .map(row =>
            row?.[entityNameColumnIndex]?.value
              ?.toString()
              ?.trim()
              ?.toLowerCase()
          )
          .filter(Boolean)
      );
 
      const headerRowIndex = rows.findIndex(row =>
        row.some(
          cell =>
            cell?.value?.toString()?.trim()?.toLowerCase() === "keywords"
        )
      );

      if (headerRowIndex === -1) return [];

      const headerRow = rows[headerRowIndex];
      const keywordIndex = headerRow.findIndex(
        cell => cell?.value?.toString()?.trim()?.toLowerCase() === "keywords"
      );

      if (keywordIndex === -1) return [];

      const missingMandatory = [];

      for (let i = headerRowIndex + 1; i < rows.length; i++) {
        const row = rows[i];
        if (!row?.length) continue;

        const matchedEntity = row
          .map(cell => cell?.value?.toString()?.trim())
          .find(cellValue =>
            cellValue &&
            submissionEntityNames.has(cellValue.toLowerCase())
          );

        if (!matchedEntity) continue;

        const keywords =
          row[keywordIndex]?.value
            ?.toString()
            ?.split(",")
            ?.map(keyword => keyword.trim().toLowerCase()) || [];
        if (!keywords.includes("mandatory")) continue;

        const submissionItem = summarySubmissionFileData?.find(
          item =>
            item?.key?.toString()?.trim()?.toLowerCase() ===
            matchedEntity.toLowerCase()
        );

        if (
          submissionItem?.value === null ||
          submissionItem?.value === undefined ||
          submissionItem?.value?.toString?.().trim?.() === ""
        ) {
          missingMandatory.push(matchedEntity);
        }
      }

      return missingMandatory;
    } catch (err) {
      console.error("Mandatory summary validation error:", err);
      return [];
    }
  };

  async function confirmMandatorySummaryFieldsForMarkComplete(document, transformData, inputFileType) {
    if (inputFileType === "Generic" || !transformData) {
      return true;
    }

    const summarySubmissionFileData = transformData?.summarySubmissionFileData || [];
    const templateRules = await getTemplateRules(document?.templateName);
    const templateList = await fetchTemplateListData(
      undefined,
      maxTemplateCount,
      document?.templateName,
      true
    );
    const matchedTemplateList = templateList?.templates?.filter(
      item =>
        item.TemplateName.toString().toLowerCase() ===
        document?.templateName?.toString().toLowerCase()
    );
    const templateObj = await resolveTemplateVersionFromData(
      document?.templateName,
      document?.TemplateVersionNumber,
      matchedTemplateList || [],
      templateList?.templateVersions
    );

    if (!templateObj?.TemplatePath) {
      console.error("Template not found for mandatory summary validation.");
      return true;
    }

    const validationResult = await validateMandatorySummaryFields(
      {
        docPath: templateObj.TemplatePath,
        instanceRegion: instanceDetails?.InstanceRegion || instanceDetails?.instanceRegion,
        instanceBucket: instanceDetails?.InstanceBucket || instanceDetails?.instanceBucket,
      },
      summarySubmissionFileData,
      templateRules?.metaData?.generateSummary?.summarySheetName || "Summary Details",
    );

    if (!validationResult?.length) {
      return true;
    }

    setMissingMandatoryFields(validationResult);
    setLoading(false);
    setShowMandatoryValidationModal(true);

    const shouldContinue = await new Promise(resolve => {
      validationResolveRef.current = resolve;
    });
    validationResolveRef.current = null;
    if (shouldContinue) {
      setLoading(true);
    }

    return shouldContinue;
  }

  function doEntityNamesMatch(jsonData, templateJsonData) {
    const templateSheet = templateJsonData[0];
    const headerRow = templateSheet[0];
    const entityNameIndex = headerRow.findIndex(cell => cell.value === "Entity Name");
    const rawTemplateEntityNames = templateSheet.slice(1)
      .map(row => row[entityNameIndex]?.value)
      .filter(Boolean);
    const rawJsonEntityNames = jsonData.map(item => item["Entity Name"]).filter(Boolean);

    const normalizeName = name => name?.trim().toLowerCase();
    const normalizedTemplateEntityNames = rawTemplateEntityNames.map(normalizeName);
    const normalizedJsonEntityNames = rawJsonEntityNames.map(normalizeName);

    const mismatchedNormalizedTemplateNames = normalizedTemplateEntityNames.filter(name => !normalizedJsonEntityNames.includes(name));
    const mismatchedNormalizedJsonNames = normalizedJsonEntityNames.filter(name => !normalizedTemplateEntityNames.includes(name));

    const mismatchedTemplateNames = rawTemplateEntityNames.filter(rawName =>
      mismatchedNormalizedTemplateNames.includes(normalizeName(rawName))
    );
    const mismatchedJsonNames = rawJsonEntityNames.filter(rawName =>
      mismatchedNormalizedJsonNames.includes(normalizeName(rawName))
    );

    setTemplateEntityNamesData(mismatchedTemplateNames);
    setJsonEntityNamesData(mismatchedJsonNames);

    if (normalizedTemplateEntityNames.length !== normalizedJsonEntityNames.length) return false;

    const createFreqMap = names =>
      names.reduce((map, name) => {
        map[name] = (map[name] || 0) + 1;
        return map;
      }, {});
    const freqTemplate = createFreqMap(normalizedTemplateEntityNames);
    const freqJson = createFreqMap(normalizedJsonEntityNames);
    if (Object.keys(freqTemplate).length !== Object.keys(freqJson).length) return false;
    for (const name in freqTemplate) {
      if (freqTemplate[name] !== freqJson[name]) {
        return false;
      }
    }
    return true;
  }

  function validateMeaTemplateName(templateJsonData, actualTemplateName) {
    let meaTemplateName = null;
    const firstRow = Array.isArray(templateJsonData) ? templateJsonData[0] : null;
    if (firstRow && !Array.isArray(firstRow) && typeof firstRow === "object") {
      meaTemplateName =
        templateJsonData.find(
          (item) => {
            for (const key in item||{}) {
              if(key?.toLowerCase?.() === "ai fields" && item[key]?.toLowerCase?.() === "meatemplatename") {
                  return true;
              }
            }
            return false;
          }
        )?.["Example/Description"]?.toString().trim() || null;
    } else {
      const templateSheet = templateJsonData?.[0];
      const headerRow = Array.isArray(templateSheet?.[0]) ? templateSheet[0] : [];
      const aiFieldsIndex = headerRow.findIndex(cell => String(cell?.value || "").trim().toLowerCase() === "ai fields");
      const exampleDescIndex = headerRow.findIndex(cell => String(cell?.value || "").trim().toLowerCase() === "example/description");
      if (aiFieldsIndex !== -1 && exampleDescIndex !== -1) {
        for (let i = 1; i < (templateSheet || []).length; i++) {
          const row = templateSheet[i] || [];
          const aiField = String(row?.[aiFieldsIndex]?.value || "").trim().toLowerCase();
          if (aiField === "meatemplatename") {
            meaTemplateName = String(row?.[exampleDescIndex]?.value || "").trim();
            break;
          }
        }
      }
    }
    const normalizedMeaTemplateName = String(meaTemplateName || "").trim();
    const normalizedActualTemplateName = String(actualTemplateName || "").trim();
    if (normalizedMeaTemplateName && normalizedMeaTemplateName !== normalizedActualTemplateName) {
      return {
        valid: false,
        error: `meaTemplateName mismatch. template json has "${normalizedMeaTemplateName}" but actual template is "${normalizedActualTemplateName}"`,
      };
    }
    return { valid: true };
  }

  async function validateGenericTemplate(document, s3Path){
      let jsonData, templateJsonData;
      if (s3Path !== undefined) {
        jsonData = await extractExcelData(s3Path, instanceDetails?.instanceRegion, instanceDetails?.instanceBucket);
        templateJsonData = await getTemplateJson(document, instanceDetails?.instanceRegion, instanceDetails.instanceBucket);
        const templateSheet = templateJsonData[0];
        const headerRow = templateSheet[0];
        const output1Index = headerRow.findIndex(cell => cell.value.toLowerCase() === "output 1");
        if (output1Index === -1) {
          return false;
        }else{
          return true;
        }
      } else {
        return false;
      }
  }

  async function doDocumentProcessing(username, email, document, status, rejectionReasons, outputfile, producerName, numFieldsExtracted, insuredName, brokerName, macrosOn, metaInfo) {
    var ext, outputFileName;
    let qaCompleteXlType = xlType;
    if (status === "Complete") {
      if (macrosOn === true) {
        ext = formData.uploadDocumentName.split('.');
        ext = ext[ext.length - 1].toLowerCase();
        outputFileName = replaceLastOfFile(formData.uploadDocumentName, "_macproc", ext);
      } else {
        outputFileName = formData.uploadDocumentName;
      }
    }

    try {
      var today = new Date();
      var nDate = today.toJSON().slice(0, 10);//YYYY-MM-DD
      const updDocument = {
        document_id: document.document_id,
        submissionIdentifier: document.submissionIdentifier,
        documentName: document.documentName
      };
      if (document.templateName !== undefined && document.templateName !== null) {
        updDocument.templateName = document.templateName;
      }
      if (status === "In Progress") {
        updDocument.processedby = username;
        updDocument.processingStatus = status;
        try {
          const rules = await getTemplateRules(document.templateName);
          if (rules?.metaData?.batchMarkComplete === true) {
            updDocument.batchProcessingStatus = "Pending";
          }
        } catch (err) {
          console.error("doDocumentProcessing batchMarkComplete lookup failed", err);
        }
      } else if (status === "Complete") {
        updDocument.processedby = username;
        updDocument.processedDate = nDate;
        updDocument.processingStatus = status;
        updDocument.uploadDocumentName = outputFileName;
        updDocument.uploadDocumentFullPath = outputfile;
      } else if (status === "Rejected") {
        updDocument.rejectionReasons = rejectionReasons;
        updDocument.processedby = username;
        updDocument.processedDate = nDate;
        updDocument.processingStatus = status;
      } else if (status === "Paid") {
        updDocument.processedby = username;
        updDocument.paymentDate = nDate;
        updDocument.paymentStatus = status;
      } else if (status === "QA In Progress") {
        updDocument.qaFileProcessedBy = username;
        updDocument.qaFileProcessedDate = nDate;
        updDocument.processingStatus = status;
      } else if (status === "QA Complete") {
        updDocument.qaFileProcessedBy = username;
        updDocument.qaFileProcessedDate = nDate;
        updDocument.processingStatus = status;
      }

      if (status === "Complete") {
        await cptood(document.submissionIdentifier, outputfile, outputFileName, true);
        if (formData.uploadDocumentName.toLowerCase().endsWith(".csv") === false) {
          await extractDocument(document, "edited", outputfile, outputFileName, undefined, undefined);
        }

      } else if (status === "Rejected") {
        await cptood(document.submissionIdentifier, undefined, undefined, true);
      }

      var updDocumentEscaped = { ...updDocument };
      if (updDocumentEscaped.uploadDocumentName !== undefined) {
        updDocumentEscaped.uploadDocumentName = updDocumentEscaped.uploadDocumentName.replace(/'/g, "''").replace(/"/g, "\\\"");
        updDocumentEscaped.uploadDocumentFullPath = updDocumentEscaped.uploadDocumentFullPath.replace(/'/g, "''").replace(/"/g, "\\\"");
      }
      await updateDocument(updDocumentEscaped, document.archivedQa);
      updDocumentEscaped.documentFullPath = document.documentFullPath;
      if (status === "Complete") {
        const updSubmissionReport = {
          submissionIdentifier: document.submissionIdentifier,
          document_id: document.document_id,
          SubProductName: producerName,
          NumFieldsExtracted: numFieldsExtracted,
          DeclineCode: declineCode.join(','),
          TriageLane: triageLane,
          InsuredName: insuredName,
          BrokerName: brokerName
        };
        await updateSubmissionsReport(updSubmissionReport);
        notifyUser({ "username": document.submittedby, "processorname": email, "fileName": outputFileName, "option": "documentComplete", "submissionIdentifier": document.submissionIdentifier });
        onDocumentFinish(updDocumentEscaped, status);
        let additionalDataInfo = {};
        if (xlType?.toString()?.toLowerCase() === "sov") {
          const sovMetrics = await calculateSovMetrics(outputfile || document.uploadDocumentFullPath);
          if (sovMetrics) {
            additionalDataInfo = { ...additionalDataInfo, ...sovMetrics };
          }
        }
        if (
          additionalDataInfo.TotalRowCount === undefined &&
          additionalDataInfo.TotalColumnCount === undefined &&
          numFieldsExtracted !== undefined
        ) {
          additionalDataInfo.TotalFieldsExtracted = numFieldsExtracted;
        }
        if (Object.keys(additionalDataInfo).length === 0) {
          additionalDataInfo = undefined;
        }
        logAudit(document.document_id, document.submissionIdentifier, "Submission", "Complete", "UI", additionalDataInfo, undefined, (document.templateName !== undefined && document.templateName !== null) ? document.templateName : undefined).then((data) => { });
      } else if (status === "Rejected") {
        notifyUser({ "username": document.submittedby, "processorname": email, "fileName": document.documentName, "option": "documentRejected", "submissionIdentifier": document.submissionIdentifier, "rejectionReason": updDocumentEscaped?.rejectionReasons, "metaInfo": metaInfo });
        onDocumentFinish(updDocumentEscaped, status);
        logAudit(document.document_id, document.submissionIdentifier, "Submission", "Rejected", "UI", undefined, undefined, (document.templateName !== undefined && document.templateName !== null) ? document.templateName : undefined).then((data) => { });
      } else if (status === "In Progress") {
        notifyUser({ "username": document.submittedby, "processorname": email, "fileName": document.documentName, "option": "documentInProgress", "submissionIdentifier": document.submissionIdentifier });
        logAudit(document.document_id, document.submissionIdentifier, "Submission", "In Progress", "UI", undefined, undefined, (document.templateName !== undefined && document.templateName !== null) ? document.templateName : undefined).then((data) => { });
      } else if (status === "QA Complete") {
        let getInstanceDetails = { archivedQa: document.archivedQa, spFolderPath: await getSpFolderPath(document), fetchDropdown: true, globalOpsReportsID: document.GlobalOpsReportsID, instanceName: document.InstanceName, instanceBackend: document.InstanceBackend, instanceAccountID: document.InstanceAccountID, instanceRoleID: document.InstanceRoleID, instanceRegion: document.InstanceRegion, instanceBucket: document.InstanceBucket, submissionIdentifier: document.submissionIdentifier, document_id: document.document_id };
        var getMergedDoc = await getDocDetailsList(getInstanceDetails);
        const getTransformData = await fetchTransformationJSONData(getMergedDoc, getInstanceDetails);
        if ((document?.documentName?.toString().toLowerCase().endsWith(".pdf") && getTransformData?.extractedPdfExcelPath && getTransformData?.extractedPdfJsonPath)
            || document.documentName?.toString().toLowerCase().endsWith(".xlsx")
            || document.documentName?.toString().toLowerCase().endsWith(".xls")
        ) {
            if (getTransformData === false) {
                qaCompleteXlType = "Generic";
            } else {
                qaCompleteXlType = getTransformData.inputFileType;
            }
            setXlType(qaCompleteXlType);
        }
        let jsonDiffFile = getQaDiffJsonPath(document?.qaFileFullPath);
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        var updSubmissionReport = {
            submissionIdentifier: document.submissionIdentifier,
            document_id: document.document_id,
            QASaveDateTime: "NOW",
            QASaveUser: user.attributes.email,
        };
        if (document.jsonMarkCompletePath !== null) {
            const markCompleteData = await loadS3File(document.jsonMarkCompletePath);
            const qaData = await loadS3File(document.jsonExtractpath);
            var compRes = await compareQAFeedback(markCompleteData, qaData, document, getInstanceDetails, maxTemplateCount, xlType, "QA Complete");            
            if (compRes.success !== false && compRes.diffpack !== undefined) {
                await Storage.put(jsonDiffFile, Buffer.from(JSON.stringify(compRes.diffpack), 'utf8'));
                updSubmissionReport.NumFieldsQAModified = compRes.modified;
                updSubmissionReport.NumFieldsQAAdded = compRes.added;
                updSubmissionReport.NumFieldsQADeleted = compRes.deleted;
                updSubmissionReport.ExtractionQADifferencesJsonPath = jsonDiffFile;
            }
        }
        const body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "target": "updateSubmissionsReport",
            archivedQa: document.archivedQa,
            "submissionsReportInput": updSubmissionReport
        };
        const init = {
            body: body
        };
        
        await invokeLambdaWithRetry("instanceHandler", init);
        notifyUser({ "username": document.submittedby, "processorname": email, "fileName": document.documentName, "option": "qaComplete", "submissionIdentifier": document.submissionIdentifier });
        logAudit(document.document_id, document.submissionIdentifier, "QA", "QA Complete", "UI", undefined, undefined).then((data) => { });
      } else if (status === "QA In Progress") {
        notifyUser({ "username": document.submittedby, "processorname": email, "fileName": document.documentName, "option": "qaInProgress", "submissionIdentifier": document.submissionIdentifier });
        logAudit(document.document_id, document.submissionIdentifier, "QA", "QA In Progress", "UI", undefined, undefined).then((data) => { });
      }
      return { qaCompleteXlType };
    } catch (err) {
      console.error(err);
      if (status === "QA Complete") {
        throw err;
      }
    }
  }

  const updateTransformedPathForFinish = async (document) => {
    try {
      let jsonFilePath = `${document?.documentFullPath.split('/')[0]}/DocumentsMeta/${document?.document_id}.json`;
      let jsonData = await fetchJsonData({ docPath: jsonFilePath });
      let transformedData = JSON.parse(jsonData);
      if (transformedData !== false) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          "access_token": user.signInUserSession.idToken.jwtToken,
          "target": "update-transformed-path-for-finish",
          "inputFileType": transformedData.inputFileType,
          "document_id": document.document_id,
        };
        const init = {
          body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data.response;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function doUxDocumentProcessing(document, status, msg, rejectionReasons, outputfile, producerName, numFieldsExtracted, insuredName, brokerName, metaInfo) {
    if (isArchived) document = await archivedQaActions.resolve(document);
    let qaCompleteSendConfig;
    try {
      setLoading(true);
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const persistQaComplete = async () => doDocumentProcessing(user.username, user.attributes.email, document, status, rejectionReasons, outputfile, producerName, numFieldsExtracted, insuredName, brokerName, undefined, metaInfo);

      if (status === "QA Complete") {
        try {
          qaCompleteSendConfig = await resolveQaCompleteSendConfig(
            undefined,
            () => getParameterFromManager("SEND_QA_DATA_CFG", { forceRefresh: true })
          );
        } catch (configError) {
          console.error("Classic QA Complete send configuration unavailable", {
            submissionIdentifier: document?.submissionIdentifier,
            documentId: document?.document_id,
            errorName: configError?.name || "Error"
          });
          setShowModalMsg("QA Complete could not verify the Send QA configuration. The document was not marked as QA Complete. Please retry.");
          setShowModal(true);
          return false;
        }

        if (document?.archivedQa) {
          const saved = await savedQALargeFileBackend(document, undefined, document.clientQASubmissionNum, 'QA Complete', {}, document.inputFileType,
            { preserveReviewNotes: true, sendOnComplete: qaCompleteSendConfig.shouldSend, selectMode: 'all' });
          if (saved?.success !== true || !saved.document) throw new Error('Archived QA completion did not confirm its document.');
          await fetchDocuments(true, undefined, undefined, undefined, isArchived);
          setShowModalMsg(msg); setShowModal(true); return saved;
        }
        if (qaCompleteSendConfig.shouldSend) {
          const diagnosticReference = `QA-${uuid().replace(/-/g, "").slice(0, 8).toUpperCase()}`;
          let persistedDetails;
          const sendQaResult = await persistBeforeQaCompleteDelivery({
            persist: async () => {
              persistedDetails = await persistQaComplete();
            },
            deliver: () => notifyClientWithDetails(
              document.submissionIdentifier,
              document.documentName,
              document.clientQASubmissionNum ?? "",
              document.document_id,
              persistedDetails?.qaCompleteXlType || xlType,
              document.templateName,
              "all",
              "QA Complete",
              { diagnosticReference, archivedQa: document.archivedQa }
            )
          });

          if (!sendQaResult?.success) {
            console.error("Classic Send QA with QA Complete failed", {
              diagnosticReference: sendQaResult?.diagnosticReference || diagnosticReference,
              failureCode: sendQaResult?.failureCode || SEND_QA_FAILURE_CODE.REQUEST_REJECTED,
              documentId: document?.document_id
            });
            setShowModalMsg(buildSendQaFailureNotice({
              stage: SEND_QA_FAILURE_STAGE.DELIVERY_REQUEST,
              code: sendQaResult?.failureCode || SEND_QA_FAILURE_CODE.REQUEST_REJECTED,
              documentStatus: "QA Complete",
              reference: sendQaResult?.diagnosticReference || diagnosticReference,
              delivery: sendQaResult?.delivery
            }));
            setShowModal(true);
            await fetchDocuments(true, undefined, undefined, undefined, isArchived);
            return false;
          }

          if (!isSendQaAsyncAcceptedResponse(sendQaResult.message)) {
            try {
              await handleUpdateSubmissionReport({
                submissionIdentifier: document.submissionIdentifier,
                document_id: document.document_id,
                SendQADateTime: "NOW"
              });
            } catch (reportError) {
              console.error("Classic Send QA delivery timestamp update failed", {
                diagnosticReference: sendQaResult?.diagnosticReference || diagnosticReference,
                documentId: document?.document_id,
                errorName: reportError?.name || "Error"
              });
            }
          }
          logAudit(document.document_id, document.submissionIdentifier, "QA", "Send QA Data", "UI", undefined, undefined).then((data) => { });
        } else {
          await persistQaComplete();
        }
      } else {
        await persistQaComplete();
      }
      setRejectionReasons('');
      setShowModalCompleteOrReject(false);
      setShowModalMsg(msg);
      setShowModal(true);
      await fetchDocuments(true, undefined, undefined, undefined, isArchived);
    } catch (err) {
      if (err === "The user is not authenticated") {
        signOutUser();
      }
      console.error(err);
      if (status === "QA Complete") {
        setShowModalMsg(buildSendQaFailureNotice({
          stage: SEND_QA_FAILURE_STAGE.QA_COMPLETE_FINALIZATION,
          code: SEND_QA_FAILURE_CODE.UNEXPECTED
        }));
        setShowModal(true);
      }
      return false;
    } finally {
      setLoading(false);
    }
  }

  async function removeDocument(e, document) {
    e.preventDefault();
    try {
      setLoading(true);
      try {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        await deleteDocument(document.document_id);
        notifyUser({ "username": document.submittedby, "processorname": user.attributes.email, "fileName": document.documentName, "option": "documentDeleted", "submissionIdentifier": document.submissionIdentifier });
        logAudit(document.document_id, document.submissionIdentifier, "Submission", "Deleted", "UI", undefined, undefined).then((data) => { });
      } catch (err) {
        if (err === "The user is not authenticated") {
          signOutUser();
        }
        console.error(err);
      }
      await fetchDocuments(true, undefined, undefined, undefined, isArchived);
    } finally {
      setLoading(false);
    }
  }

  function rowKeyGetter(row) {
    return row.document_id;
  }

  function getExtractPath(documentFullPath) {
    var docFPs = documentFullPath.split('/');
    docFPs.pop();
    return docFPs.join('/');
  }

  async function setNewDocumentForUpload(e, processed) {
    try {
      if (processed === true) {
        const file = e.target.files[0];
        const uuidForPath = uuid();
        var pathForExtracts = undefined;
        if (documentObj.document.documentFullPath !== null && documentObj.document.documentFullPath !== undefined) {
          pathForExtracts = getExtractPath(documentObj.document.documentFullPath);
        } else {
          var res = await fetchMsg(documentObj.document.submissionIdentifier);
          pathForExtracts = getExtractPath(res.data.listDocumentsAnyWithMsg[0].documentFullPath);
        }
        setFormData({ ...formData, uploadDocumentName: file.name, uploadDocumentFullPath: `${pathForExtracts}/${uuidForPath}${file.name}`, file: file, target: e.target });
      } else {
        setFormData({ ...formData, files: e.target.files, target: e.target });
      }
    } catch (err) {
      console.error(err);
      if (err === "The user is not authenticated") {
        signOutUser();
      }
    }
  }

  async function onMergeFileChange(e) {
    if (!e.target.files[0])
      return;
    if (documentObj.document.documentName.toLowerCase() !== e.target.files[0].name.toLowerCase()) {
      setShowModalMsg(`Merge file does not match ${documentObj.document.documentName}`);
      setShowModal(true);
      e.target.value = null;
      return;
    }
    var file = e.target.files[0];
    setFormData({ ...formData, file: file, target: e.target });
  }

  function isAllowedExtension(filePath, processed) {
    var filePathParts = filePath.toLowerCase().split('.');
    if (processed === true) {
      if (mcUploadExt.split(',').map((i) => i.trim()).includes(`.${filePathParts[filePathParts.length - 1]}`) === true) {
        return true;
      }
    }
    else if (allowedExtensions.split(',').map((i) => i.trim()).includes(`.${filePathParts[filePathParts.length - 1]}`) === true) {
      return true;
    }
    return false;
  }

  async function onChange(e, processed) {
    if (!e.target.files[0]) {
      if (processed) {
        setFormData({ ...formData, uploadDocumentName: '', uploadDocumentFullPath: '', file: null, target: null });
      }
      return;
    }
    if (e.target.files.length > 0) {
      setSelectedFileName(e.target.files);
    } else {
      setSelectedFileName('');
    }

    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    for (var m = 0; m < e.target.files.length; m++) {
      var fileAllowed = isAllowedExtension(e.target.files[m].name, processed);
      if (fileAllowed === false) {
        if (processed === true) {
          setShowModalMsg(`Only ${mcUploadExt} are allowed to be used to mark the submission as complete`);
        } else {
          setShowModalMsg(`The file type you are trying to upload is not supported. Supported file type extension are ${allowedExtensions}`);
        }
        setShowModal(true);
        e.target.value = null;
        setFormData({ ...formData, files: null });
        return;
      }
    }

    for (var i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i]?.size === 0) {
        e.target.value = null;
        setShowModalMsg(`The file size being uploaded is 0 bytes. Please upload a valid submission file.`);
        setShowModal(true);
        setFormData({ ...formData, files: null });
        return;
      }
    }

    var fileSizeLimit = await getFileSizeLimit(user.attributes.email.split("@")[1].toLowerCase());
    if (fileSizeLimit !== -1) {
      for (let i = 0; i < e.target.files.length; i++) {
        if (e.target.files[i].size > fileSizeLimit) {
          e.target.value = null;
          setShowModalMsg(`The file size being uploaded is more than the defined file size threshold of ${fileSizeLimit / 1024 / 1024} MB. Contact your system admin or reach out to mea support for more clarificaiton`);// ${e.target.files[i].name}
          setShowModal(true);
          setFormData({ ...formData, files: null });
          return;
        }
      }
    }

    for (let i = 0; i < e.target.files.length; i++) {
      let meaValidationsCheck = await getParameterFromManager(`MEA_VALIDATIONS_CHECK`);
      const domain = user.attributes.email.split("@")[1].toLowerCase();
      const validationRules = getMergedMeaValidationCheckRules(meaValidationsCheck, meaValidationsCheck[domain] === undefined ? "default" : domain);
      if (e.target.files[i].name.length > validationRules.max_filename_length) {
        e.target.value = null;
        setShowModalMsg(`The file name length is more than ${validationRules.max_filename_length} chars, shorten the file name and upload it again`);
        setShowModal(true);
        setFormData({ ...formData, files: null });
        return;
      }

      // Validate filename using config from MEA_VALIDATIONS_CHECK
      const validationResult = validateFileName(e.target.files[i].name, validationRules);
      if (!validationResult.isValid) {
        e.target.value = null;
        setShowModalMsg(validationResult.error);
        setShowModal(true);
        setFormData({ ...formData, files: null });
        return;
      }
    }

    if (!processed) {
      setEnableTemplate(false);
      var tplEnabled = await getParameterFromManager("USE_TEMPLATE");
      if (tplEnabled !== false) {
        for (let i = 0; i < e.target.files.length; i++) {
          if (isTemplateAllowed(e.target.files[i].name) === true) {
            setEnableTemplate(true);
          }
        }
      }
    }

    if (processed === true && (documentObj.document.uploadDocumentName !== undefined) && (documentObj.document.uploadDocumentName !== null) && (documentObj.document.uploadDocumentName !== "") && (e.target.files[0].name.toLowerCase() !== documentObj.document.uploadDocumentName.toLowerCase())) {
      setEvtShowModalYesNo({ "params": e, "option": "upload-docs" });
      setShowModalYesNoMsg(`The newly uploaded document \n<b>${e.target.files[0].name}</b> differs from the original extracted file <b>${documentObj.document.uploadDocumentName}</b>. Do you want to continue ?`);
      setShowModalYesNo(true);
      return;
    }
    await setNewDocumentForUpload(e, processed);
  }

  const TAG_FALLBACK_PATTERN = /^[a-zA-Z0-9 \-_.:\/]+$/;

  function getTagPattern() {
    if (tagAllowedPattern) {
      try {
        return new RegExp(tagAllowedPattern);
      } catch (e) {
        console.warn("Invalid tag_allowed_chars regex in config:", tagAllowedPattern, e);
      }
    }
    return TAG_FALLBACK_PATTERN;
  }

  function isInvalidTagText(value) {
    if (!value || value.trim().length === 0) return true;
    const pattern = getTagPattern();
    return !pattern.test(value.trim());
  }

  function escapeRegExp(str) {
    return typeof str === 'string' ? str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : str;
  }

  function getInvalidTagChars(value) {
    const pattern = getTagPattern();
    let charPattern;
    try {
      const src = pattern.source.replace(/^\^/, '').replace(/\$$/, '');
      charPattern = new RegExp(`^(?:${src})$`);
    } catch (e) {
      charPattern = /^[a-zA-Z0-9 \-_.:\/]$/;
    }
    const invalid = [...new Set(value.split('').filter(ch => !charPattern.test(ch)))];
    return invalid;
  }

  function isInvalidSubmissionId(submissionIdentifier) {
    if (submissionIdentifier.trim().length === 0)
      return true;
    if (getSubmissionIdentifierError(submissionIdentifier)) {
      return true;
    }
    if (showCountryCodes === true) {
      //The submission Identifier would be of the format lobcode-countrycode-subid value if the "Enable Country Code Validation" is enabled.
      var subidparts = submissionIdentifier.split('-');
      if (subidparts.length < 3) {
        return true;
      }
      var ctryCode = assocCtryCodeOptions.filter(obj => {
        return obj.value.toLowerCase() === subidparts[1].toLowerCase();
      });
      if (ctryCode === undefined || ctryCode.length !== 1) {
        return true;
      }
      var lobCode = lobCodeOptions.filter(obj => {
        return obj.LOBCode.toLowerCase() === subidparts[0].toLowerCase();
      });
      if (lobCode === undefined || lobCode.length !== 1 || lobCode[0].AssocCountryCodes === null || lobCode[0].AssocCountryCodes === undefined || (lobCode[0].AssocCountryCodes.toLowerCase().split(',').includes(ctryCode[0].value.toLowerCase()) === false)) {
        return true;
      }
    }
    return false;
  }

  const onDeclineCodesChange = val => {
    if (val.trim().length === 0) {
      setDeclineCode([]);
    } else {
      setDeclineCode(val.trim().split(','));
    }
  }

  function disallowSubmission(file, files) {
    if (file === null && files === null) {
      return true
    }
    if (file !== null) {
      if (isAllowedExtension(file.name) === false) {
        return true;
      }
    }
    if (files !== null) {
      for (var i = 0; i < files.length; i++) {
        if (isAllowedExtension(files[i].name) === false)
          return true;
      }
    }
    return false;
  }

  async function onSearchTextChange(event) {
    const value = event.target.value;
    setSearchText(event.target.value);
    var procStatusExplicit = "";
    if (value.length < 1) {
      setLoading(true);
      await fetchDocuments(true, procStatusExplicit, 'nofilter', undefined, isArchived);
      setLoading(false);
    }
    if (value.length > 3) {
      setShowSuggestions(true);
      let filterData = await getSearchSuggestions(value);
      setCurrentData(filterData);
    } else {
      setShowSuggestions(false);
      setCurrentData([]);
    }
  }

  const showFileNames = () => {
    let fileNames = [];
    for (var i = 1; i < selectedFileName.length; i++) {
      fileNames.push(selectedFileName[i].name)
    }
    return <><br /><p className="btntool show-more-files" data-toggle="tooltip" data-placement="bottom" title={fileNames.join("\n")} >
      More files...
    </p></>
  }

  useEffect(() => {
    const closeIcon = document.querySelector(".reactour__close-button");
    if (closeIcon) {
      closeIcon.addEventListener("click", () => {
        setTourNewSubmissionVisible(false);
        onClickClose();
      });
    }
  }, [currentStep])

  useEffect(() => {
    setSelectedFileName('');
    setTemplateName([]);
    setFormData(initialFormState);
  }, [submissionModal])


  const mapTemplateOptions = () => {
    let filteredTemplateOptions = [];
    var subidparts = submissionIdentifier.split('-').map(part => part.toLowerCase());
    if(lobCodeValidationEnabled === true && showCountryCodes === true ) {
      filteredTemplateOptions = templateOptions.filter(template => {
        return userGroups.some(group => {
            const templateNameLowerCase = template.TemplateName.toLowerCase();
            if(templateNameLowerCase.startsWith(`default`)) {
                return true;
            }
            if(group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP && (templateNameLowerCase.startsWith(`${subidparts[0]}-${subidparts[1]}-`) || templateNameLowerCase.startsWith(`${subidparts[0]}-default`))) {
              return true;
            }
            const lobCodeLowerCase = group.LOBCode.toLowerCase();
            const countryCodeLowerCase = group.CountryCode.toLowerCase();
            if(subidparts.length >= 1) {
                if(templateNameLowerCase.startsWith(`${subidparts[0]}-default`) && (lobCodeLowerCase === subidparts[0] || lobCodeLowerCase === "default")) {
                    return true;
                }
            }
            if(subidparts.length >= 2) {
                if(templateNameLowerCase.startsWith(`${subidparts[0]}-${subidparts[1]}-`) && (lobCodeLowerCase === subidparts[0] || lobCodeLowerCase === "default") && (countryCodeLowerCase === subidparts[1] || countryCodeLowerCase === "default")) {
                    return true;
                }
            }
            return false;
        });
      });
    } else if(lobCodeValidationEnabled === true && showCountryCodes === false ) {
      filteredTemplateOptions = templateOptions.filter(template => {
        return userGroups.some(group => {
            const templateNameLowerCase = template.TemplateName.toLowerCase();
            if(templateNameLowerCase.startsWith(`default`)) {
                return true;
            }
            if(group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP && templateNameLowerCase.startsWith(`${subidparts[0]}-`)) {
              return true;
            }
            const lobCodeLowerCase = group.LOBCode.toLowerCase();
            if(subidparts.length >= 1) {
                if(templateNameLowerCase.startsWith(`${subidparts[0]}-`) && (lobCodeLowerCase === subidparts[0] || lobCodeLowerCase === "default")) {
                    return true;
                }
            }
            return false;
        });
      });
    } else if(lobCodeValidationEnabled === false && showCountryCodes === true ) {
      filteredTemplateOptions = templateOptions.filter(template => {
        return userGroups.some(group => {
            const templateNameLowerCase = template.TemplateName.toLowerCase();
            if(templateNameLowerCase.startsWith(`default`)) {
                return true;
            }
            if(group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP && templateNameLowerCase.startsWith(`${subidparts[0]}-`)) {
              return true;
            }
            const countryCodeLowerCase = group.CountryCode.toLowerCase();
            if(subidparts.length >= 1) {
                if(templateNameLowerCase.startsWith(`${subidparts[0]}-`) && (countryCodeLowerCase === subidparts[0] || countryCodeLowerCase === "default")) {
                    return true;
                }
            }
            return false;
        });
      });
    } else if(lobCodeValidationEnabled === false && showCountryCodes === false ) {
      filteredTemplateOptions = templateOptions;
    }
    if(filteredTemplateOptions.length > 0 && templateName.length === 0) {
      setTemplateName([{value: filteredTemplateOptions[0].TemplateName, label: filteredTemplateOptions[0].TemplateName}]);
    }
    if(lobCodeValidationEnabled === true && showCountryCodes === true){
      filteredTemplateOptions = filteredTemplateOptions.filter(template =>
        template.TemplateName.toLowerCase() === "default template" || template.TemplateName.toLowerCase().startsWith(`${subidparts[0]}-${subidparts[1]}-`)
      )
    }
    return filteredTemplateOptions;
  };

  const filteredUserGroups = () => {
    let filteredUg = [];
    let templateList = templateName?.map(item => item.value.toLowerCase()) || [];
    var subidparts = submissionIdentifier.split('-').map(part => part.toLowerCase());
    if(lobCodeValidationEnabled === true && showCountryCodes === true ) {
        filteredUg = userGroups.filter(group => {
            if(group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP)
                return true;
            const countryCodeLowerCase = group.CountryCode.toLowerCase();
            const lobCodeLowerCase = group.LOBCode.toLowerCase();
            if (countryCodeLowerCase !== "default" && lobCodeLowerCase !== "default") {
              return templateName.length > 0 && templateList?.every(templateNameLowerCase => 
                templateNameLowerCase.startsWith(`${lobCodeLowerCase}-${countryCodeLowerCase}-`) ||
                templateNameLowerCase.startsWith(`${lobCodeLowerCase}-default`) ||
                (lobCodeLowerCase === subidparts[0] && countryCodeLowerCase === subidparts[1])
              );
            } else if (countryCodeLowerCase === "default" && lobCodeLowerCase === "default") {
                return true;
            } else if (countryCodeLowerCase === "default") {
              return  templateName.length > 0 && templateList?.every(templateNameLowerCase => 
                templateNameLowerCase.startsWith(`${lobCodeLowerCase}-`) || lobCodeLowerCase === subidparts[0]
              );
            } else  {//if (lobCodeLowerCase === "default")
              return templateName.length > 0 && templateList?.every(templateNameLowerCase => 
                templateNameLowerCase.startsWith(`${countryCodeLowerCase}-`) || countryCodeLowerCase === subidparts[1]
              );
            }
        });
    } else if(lobCodeValidationEnabled === true && showCountryCodes === false ) {
        filteredUg = userGroups.filter(group => {
            const lobCodeLowerCase = group.LOBCode.toLowerCase();
            if (lobCodeLowerCase === "default") {
              return true;              
            } else {
              return group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP 
              || (templateName.length > 0 && templateList?.every(templateNameLowerCase => templateNameLowerCase.startsWith(`${group.LOBCode}-`)))
              || lobCodeLowerCase === subidparts[0] ;
            }
        });
    } else if(lobCodeValidationEnabled === false && showCountryCodes === true ) {
        filteredUg = userGroups.filter(group => {
            const countryCodeLowerCase = group.CountryCode.toLowerCase();
            if (countryCodeLowerCase === "default") {
              return true;              
            } else {
              return group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP 
              || (templateName.length > 0 && templateList?.every(templateNameLowerCase => templateNameLowerCase.startsWith(`${group.CountryCode}-`))) 
              || countryCodeLowerCase === subidparts[0] ;
            }
        });
    } else if(lobCodeValidationEnabled === false && showCountryCodes === false ) {
      filteredUg = userGroups;
    }
    if(filteredUg.length > 0 && selectedGroup !== filteredUg[0].group_id) {
      setSelectedGroup(filteredUg[0].group_id);
    }
    return filteredUg;
  };

  const fetchTagsValues = async () => {
    const tagsList = await getParameterFromManager('TAGS_META_INFO');
    setTagsList(tagsList.default_tags);
  }

  const handleStatusChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    const totalStatusOptions = QAStatusOptions.length;
    const isAllSelected = selectedValues.includes("All");

    // Case 1: If "All Status" is selected -> select all statuses
    if (isAllSelected && selectedValues.length === 1) {
      setProcStatus(["All", ...QAStatusOptions]); // Select all statuses
    }
    // Case 2: If "All Status" is selected but user deselects any other option -> unselect "All Status" and keep remaining options
    else if (isAllSelected && selectedValues.length > 1 && selectedValues.length < totalStatusOptions + 1 && procStatus.includes("All")) {
      const updatedSelections = selectedValues.filter(value => value !== "All");
      setProcStatus(updatedSelections); // Remove "All Status"
    }

    // Case 3: If no statuses are selected -> unselect all statuses (including "All Status")
    else if (selectedValues.length === 0 || (selectedValues.length === totalStatusOptions && !isAllSelected && procStatus.includes("All"))) {
      setProcStatus([]); // Unselect all statuses (including "All Status")
    }
    // Case 4: If all statuses except "All Status" are selected -> automatically select "All Status"
    else if (selectedValues.length === totalStatusOptions && !isAllSelected) {
      setProcStatus(["All", ...QAStatusOptions]); // Automatically select "All Status"
    }
    // Case 5: Normal multi-select behavior
    else {
      isAllSelected && selectedValues.length !== QAStatusOptions.length && defaultProcStatus.length === totalStatusOptions ? setProcStatus(["All", ...QAStatusOptions]) : isAllSelected ? setProcStatus(["All", ...QAStatusOptions]) : setProcStatus(selectedValues); // Normal multi-select behavior
    }
  };

  async function submissionDataLake(document, email, s3Path) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        "target": "extractDocument",
        "access_token": user.signInUserSession.idToken.jwtToken,
        "option": "submission_data_lake",
        "submissionIdentifier": document.submissionIdentifier,
        "document_id": document.document_id,
        "inputfile": s3Path,
        "templateName": document?.templateName,
        "UserId": email
      };
      const init = {
        body: JSON.stringify(body),
      };
      await invokeLambdaWithRetry("instanceHandler", init);
      return true;
    } catch (err) {
      return false;
    }
  }

  if (showMissingGroupState) {
    return (
      <Container fluid className="p-0">
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover submissions-listing-uploadusers">
              <Card.Body>
                <Card.Title>No group assignment found</Card.Title>
                <p className="mb-0">
                  This user is not assigned to any group. Ask an administrator to
                  assign at least one group before using Submission Summary.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      <Container fluid className="p-0">
        {dataTour && <div className="ml-3 p-1">
          <button className="button-start" onClick={(event) => {
            event.preventDefault();
            setTourNewSubmissionVisible(true);
            setSteps(steps["submissions"]);
            setCurrentStep(0);
            setIsOpen(true);
          }}>Turn On Tour
          </button>
        </div>
        }
        <Form>
          <Row>
            <Col md="12">
              <Card className={(userRole === 'MEA_USERS' || userRole === 'MEA_CORPORATE' || userRole === 'MEA_ADMIN') ? "strpied-tabled-with-hover submissions-listing-uploadusers" : "strpied-tabled-with-hover submissions-listing-full"}>
                <Card.Header>
                  <Card.Title className="row mx-0 h5 mb-0 filter-submission">
                    {/* <NotificationManager /> */}
                    <div className="filter-submission-left col-md-1 col-sm-6 col-6 pl-0 pr-1 pt-2 icon-search">
                      <span className="mr-1 icon-static d-inline"><BiSearch /></span>
                    </div>
                    <div className="filter-submission-right">
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-1 pl-1 pr-1">
                          <label><span className="mr-1 d-inline"></span>Find a</label>
                          <select className="form-control filter-inputdropdown" id="typeOfInput" value={searchType} onChange={(event) => {
                            setCurrentData([]);
                            setSearchType(event.target.value);
                            setSearchText('');
                          }}>
                            {
                              getSearchOptions().map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))
                            }
                          </select>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-1 pl-2 pr-1">
                          <label className="mb-0 mr-3">in</label>
                          <Select
                            id="listOfLobs"
                            className="form-control dropdown-listofccodes p-0 border-0 dropdown-lobscolor"
                            classNamePrefix=" dropdown-lobscolor"
                            isSearchable={false}
                            isClearable={false}
                            value={{
                              value: lobCodeDisplay,
                              label: lobCodeDisplay
                            }}
                            onChange={(selected) => {
                              if (!selected || selected.value === "All LOBs") {
                                setLOBCode("All");
                                setLOBCodeDisplay("All LOBs");
                              } else {
                                setLOBCode(selected.originalValue.LOBCode);
                                setLOBCodeDisplay(selected.value);
                              }
                            }}
                            options={[
                              { value: "All LOBs", label: "All LOBs" },
                              ...(lobCodeOptions || []).map(option => ({
                                value: `${option.LOBCode} - ${option.LineOfBusiness}`,
                                label: `${option.LOBCode} - ${option.LineOfBusiness}`,
                                originalValue: option
                              }))
                            ]}
                            onMenuScrollToBottom={() => {
                              // Only fetch if we have more data
                              if (hasMoreLobs) {
                                setLobCurrentPage(prev => prev + 1);
                                fetchLOBCodeList();
                              }
                            }}
                          />
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-6 col-6 mb-1 pl-1 pr-1">
                          <label>in</label>
                          <select className="form-control dropdown-listofccodes" id="listOfCcodes" value={countryCodeDisplay} onChange={(event) => {
                            if (event.target.selectedIndex === 0) {
                              setCountryCode("All");
                              setCountryCodeDisplay(event.target.value);
                            } else {
                              setCountryCode(assocCtryCodeOptions[event.target.selectedIndex - 1].value);
                              setCountryCodeDisplay(event.target.value);
                            }
                          }}>
                            <option key="All Countries">{"All Countries"}</option>
                            {
                              assocCtryCodeOptions && assocCtryCodeOptions.map(assocCtryCodeOptions => (
                                <option key={assocCtryCodeOptions.value}>{`${assocCtryCodeOptions.label}`}</option>
                              ))
                            }
                          </select>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-1 pl-1 enter-submissionid">
                          <label>named</label>
                          <input
                            id="search"
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            placeholder={`Enter ${showClaims ?"claim ID" : "submission ID"}`}
                            value={searchText}
                            onChange={async (e) => {
                              onSearchTextChange(e);
                            }}
                            disabled={!displaySubHistFromDate}
                            onKeyDown={async (e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                searchMode = "Filtered";
                                setSearchMode("Filtered");
                                setLoading(true);
                                let isChecked = document.getElementById('Show-archived-checkbox').checked;
                                await fetchDocuments(true,undefined,undefined,undefined,isChecked);
                                setLoading(false);
                              }
                            }}
                          />
                          {showSuggestions && currentData.length > 0 && (
                            <ul className="suggestions">
                              {currentData.map((item, index) => (
                                <li
                                  key={index}
                                  onClick={() => {
                                    setSearchText(item);
                                    setCurrentData([]);
                                    searchMode = "Filtered";
                                    setSearchMode("Filtered");
                                    setLoading(true);
                                    fetchDocuments(true, undefined, undefined, undefined, isArchived);
                                    setLoading(false);
                                  }}
                                >
                                  {item}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-6 filter-todate mt-1 pl-1 pr-1">
                          <label>Date</label>
                          <DatePicker
                            placeholderText="From"
                            value={displaySubHistFromDate}
                            className="form-control date-fld"
                            selected={displaySubHistFromDate}
                            dateFormat="dd/MM/yyyy hh:mm:ss a"
                            showTimeSelect
                            maxDate={displaySubHistToDate}
                            onChange={(event) => {
                              const fromDateTimeFormat =
                                moment(event).format("YYYY-MM-DD HH:mm:ss");
                              if (subHistToDate !== "") {
                                if (fromDateTimeFormat <= subHistToDate) {
                                  setDisplaySubHistFromDate(event);
                                  setSubHistFromDate(fromDateTimeFormat);
                                } else {
                                  setDisplaySubHistFromDate(event);
                                  setSubHistFromDate("");
                                }
                              } else {
                                setDisplaySubHistFromDate(event);
                                setSubHistFromDate(fromDateTimeFormat);
                              }
                            }}
                          />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-6 filter-fromdate mt-1 pl-1 pr-1">
                          <label>and</label>
                          <DatePicker
                            placeholderText="To"
                            className="form-control date-fld"
                            selected={displaySubHistToDate}
                            dateFormat="dd/MM/yyyy hh:mm:ss a"
                            showTimeSelect
                            minDate={displaySubHistFromDate}
                            onChange={(event) => {
                              const toDateTimeFormat =
                                moment(event).format("YYYY-MM-DD HH:mm:ss");
                              if (subHistFromDate !== "") {
                                if (toDateTimeFormat >= subHistFromDate) {
                                  setDisplaySubHistToDate(event);
                                  setSubHistToDate(toDateTimeFormat);
                                } else {
                                  setDisplaySubHistToDate("");
                                  setSubHistToDate("");
                                }
                              } else {
                                setDisplaySubHistToDate(event);
                                setSubHistToDate(toDateTimeFormat);
                              }
                            }}
                          />
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-3 col-6 mt-1 pl-1 pr-1 ">
                          <div className="listofstatus">
                            <Select id="selectSubmissionStatusList"
                              isMulti={true}
                              isSearchable={false}
                              closeMenuOnSelect={false}
                              value={procStatus.map(status => ({ value: status, label: status === "All" ? "All Status" : status }))}
                              onChange={handleStatusChange}
                              hideSelectedOptions={false}
                              options={[
                                { value: "All", label: "All Status" }, // Optional "All Status" option
                                ...QAStatusOptions.map(status => ({
                                  value: status,
                                  label: status
                                }))
                              ]}
                              classNamePrefix="custom-select"
                              components={{
                                ClearIndicator: () => null,
                                ValueContainer,
                                Option: ({ children, isSelected, ...props }) => {
                                  return (
                                    <ReactSelectComponents.Option {...props} isSelected={isSelected}>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <span>{children}</span>
                                        {isSelected ? <span className="check_icon"><i className="fas fa-check"></i></span> : null}
                                      </div>
                                    </ReactSelectComponents.Option>
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 col-12 filter-actions d-flex justify-content-end mt-1 pl-1">
                          <div className="align-items-center">
                            <div className="showarchive">
                              <input type="checkbox" id="Show-archived-checkbox" className="border-left-0" onChange={() => { setShowArchived(!showArchived); }} checked={showArchived} />
                              <label>Show Archived</label>
                            </div>
                          </div>
                          <div className="btn-search-refresh">
                            <ul className="list-inline mb-0 d-flex align-items-center justify-content-end ">
                              <li key="search" className="list-inline-item">
                                <button type="button" id="submissionHistorySearch" className="btn btn-primary btn-sm font-weight-medium ml-2" disabled={!isSearchEnabled || procStatus.length === 0} onClick={async (e) => {
                                  e.preventDefault();
                                  searchMode = "Filtered";
                                  setSearchMode("Filtered");
                                  setCurrentPage(0);
                                  pageInputRef.current.value = '';
                                  setLoading(true);
                                  await fetchDocuments(true, undefined, undefined, undefined, showArchived, true);
                                  setLoading(false);
                                }} >Search</button>
                              </li>
                              <li key="clearandrefresh" className="list-inline-item" data-tour="step-7">
                                <button type="button" id="refreshSubmissionBtn" className="btn btn-primary btn-md btn-reduce refresh-icon" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Clear & Refresh" onClick={async (e) => {
                                  if (!isOpen) {
                                    e.preventDefault();
                                    setShowArchived(false);
                                    setIsArchived(false);
                                    setSearchMode("Full");
                                    setLoading(true);
                                    const newFromDate = moment().subtract(durationInDays, "days").startOf("day").toDate();
                                    if (!displaySubHistFromDate) {
                                      setDisplaySubHistFromDate(newFromDate);
                                      setSubHistFromDate(moment(newFromDate).format("YYYY-MM-DD HH:mm:ss"));
                                    } else if (newFromDate.getTime() !== displaySubHistFromDate.getTime()) {
                                      setDisplaySubHistFromDate(newFromDate);
                                    }
                                    setDisplaySubHistToDate(moment().endOf("day").toDate());
                                    const allStatus = defaultProcStatus.length === QAStatusOptions.length ? ["All", ...defaultProcStatus] : defaultProcStatus
                                    setProcStatus(allStatus);
                                    setLOBCodeDisplay("All");
                                    setCountryCodeDisplay("All");
                                    setSearchBased(`${serverTimeZone} - Default`);
                                    setOffsetValue(undefined);
                                    await fetchDocuments(true, undefined, "nofilter", undefined, undefined,true, defaultProcStatus);
                                    pageInputRef.current.value = '';
                                    setSearchText('');
                                    setLoading(false);
                                  }
                                }} ><i className="fas fa-sync"></i></button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 text-right mt-4 p-0">
                      <button type="button" disabled={currentPage === 0} className="btn btn-primary btn-sm font-weight-medium mr-2" onClick={async (e) => {
                        e.preventDefault();
                        setLoading(true);
                        currentPage = currentPage - 1;
                        setCurrentPage(currentPage);
                        await fetchDocuments(false, undefined, undefined, undefined, isArchived);
                        pageInputRef.current.value = ''; // clear the text field
                        setLoading(false);
                      }}>Prev</button>
                      <p className="d-inline-block gotopage mr-1">
                        <input type="number" autoComplete="off" maxLength={4} className="form-control" placeholder="Go to Page" ref={pageInputRef} onKeyDown={async (e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            setLoading(true);
                            let totalSubmissionCount = (Math.ceil(submissionCount / pageSize));
                            if (e.target.value <= 0 || totalSubmissionCount <= 0) {
                              e.target.value = 1;
                            } else if (e.target.value > totalSubmissionCount) {
                              e.target.value = totalSubmissionCount;
                            }
                            let pageNumber = parseInt(e.target.value);
                            currentPage = pageNumber - 1;
                            setCurrentPage(currentPage);
                            await fetchDocuments(false, undefined, undefined, undefined, isArchived);
                            setLoading(false);
                          }
                        }} />
                      </p>
                      <p className="d-inline">{currentPage + 1} of {submissionCount === -1 ? 1 : Math.ceil(submissionCount / pageSize) === 0 ? 1 : Math.ceil(submissionCount / pageSize)}</p>
                      <button type="button" disabled={((currentPage + 1) === (Math.ceil(submissionCount / pageSize))) || (submissionCount <= 0)} className="btn btn-primary btn-sm font-weight-medium ml-2" onClick={async (e) => {
                        e.preventDefault();
                        setLoading(true);
                        currentPage = currentPage + 1;
                        setCurrentPage(currentPage);
                        await fetchDocuments(false, undefined, undefined, undefined, isArchived);
                        pageInputRef.current.value = ''; // clear the text field
                        setLoading(false);
                      }}>Next</button>
                    </div>
                  </Card.Title>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive submission-list">
                  <DataGrid columns={columns} rows={documents} getRowId={(rowData) => rowData.submissionIdentifier} rowId={rowData => `${rowData.submissionIdentifier}`} groupBy={["submissionIdentifier"]} rowGrouper={rowGrouper} defaultColumnOptions={{ resizable: true }}
                    expandedGroupIds={expandedGroupIds}
                    onExpandedGroupIdsChange={setExpandedGroupIds}
                    rowKeyGetter={rowKeyGetter}
                    rowHeight={45}
                    className="fill-grid submissions-history-table"
                    rowClass={rowData => `${rowData.submissionIdentifier}`}
                    emptyRowsRenderer={() => (
                      <div
                        style={{
                          gridColumn: `1 / -1`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          color: "#6B7280",
                        }}
                      >
                        No Data Found
                      </div>
                    )}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Form>
        {/* Mini Modal */}
        <Modal
            className="modal-centre new-modal"
            backdrop="static"
            keyboard={false}
            show={loading}
            animation={false}
            centered={true}
          >
            <Modal.Body className="text-center">
              <CirclesLoader isLoading={loading} />
            </Modal.Body>
        </Modal>
          {/* End Modal */}
        {/* Mini Modal */}
        <Modal
          className="modal-md modal-primary new-modal"
          backdrop="static"
          show={presignedDownloadModal.show}
          onHide={closePresignedDownloadModal}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={closePresignedDownloadModal}><RiCloseLine /></button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <h4 className="mb-3">Download URL</h4>
            {presignedDownloadModal.fileName && <p className="mb-2">{presignedDownloadModal.fileName}</p>}
            <textarea
              className="form-control"
              readOnly
              rows={5}
              value={presignedDownloadModal.url}
              onFocus={(e) => e.target.select()}
            />
            {presignedDownloadModal.expiresAt && (
              <p className="mb-0 mt-2">URL expires at {presignedDownloadModal.expiresAt}</p>
            )}
            <p className="mb-0 mt-2">
              Copy the URL and paste it into a new browser tab to download the file.
            </p>
            <button
              type="button"
              className="btn btn-primary btn-md font-weight-medium mt-3"
              onClick={copyPresignedDownloadURL}
            >
              {presignedDownloadCopied ? "Copied" : "Copy URL"}
            </button>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}
        {/* Mini Modal */}
        <Modal
          className="modal-mini modal-primary modal-occur new-modal"
          backdrop="static"
          show={showModal}
          onHide={() => setShowModal(false)}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => setShowModal(false)}><RiCloseLine /></button>
          </Modal.Header>
          <Modal.Body className="text-center pt-2 pb-1">
            <p className="multi-line mb-0">{renderReactFragment(showModalMsg)}</p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        <Modal
          className="modal-centre submissions-finish new-modal"
          backdrop="static"
          show={showConsolidatedPopup}
          onHide={() => {
            setShowConsolidatedPopup(false);
            setIsConsolidatedChecked(false);
            setSelectedRow(null);
          }}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => {
              setShowConsolidatedPopup(false);
              setIsConsolidatedChecked(false);
              setSelectedRow(null);
            }}><RiCloseLine />
            </button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <div className="form-group mb-3">
              <div className="input-group justify-content-center align-items-center">
                <input
                  type="checkbox"
                  id="download-client-defined-json"
                  checked={isConsolidatedChecked}
                  onChange={(e) => setIsConsolidatedChecked(e.target.checked)}
                />
                <label className="mb-0 ml-1 h5">Download consolidated JSON</label>
              </div>
            </div>
            <button className="btn btn-primary btn-md" onClick={async () => {
              setLoading(true);
              try {
                let s3Response = await getTrfFile(
                  selectedRow.jsonExtractpath,
                  selectedRow.jsonExtractOriginalpath,
                  selectedRow.submissionIdentifier,
                  selectedRow.document_id,
                  selectedRow.uploadDocumentFullPath,
                  isConsolidatedChecked
                );
                const downloadFileName = s3Response?.fileName || getExtractedJsonDownloadName(selectedRow);
                const s3Path = s3Response.path;
                await downloadS3Object(s3Path, downloadFileName);
              } catch (error) {
                console.error("Error downloading JSON file:", error);
              } finally {
                setLoading(false);
                setShowConsolidatedPopup(false);
                setIsConsolidatedChecked(false);
                setSelectedRow(null);
              }
            }}>Download</button>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>

        {/* Mini Modal */}
        <Modal
          className="modal-md modal-primary new-modal"
          backdrop="static"
          show={showModalList}
          onHide={() => setShowModalList(false)}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => {
              setShowModalList(false);
            }}><RiCloseLine />
            </button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <Col sm={12} className="mb-2">
              {(showModalListMsg.filter((msgInfo) => msgInfo.code === "error").length === 0 ||
                showModalListMsg.length === 0) &&
                <h4>Document marked complete</h4>
              }
            </Col>
            <Col sm={12}>
              {showModalListMsg[0]?.code === "error" && <h4>Error(s)</h4>}
            </Col>
            <Col sm={12} className="modal-list d-flex justify-content-center">
              <ol>
                {
                  showModalListMsg.map(msgInfo => (
                    <li>{msgInfo.msg}</li>
                  ))
                }
              </ol>
            </Col>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        {/* Mini Modal */}
        <Modal
          className="modal-mini modal-primary new-modal"
          backdrop="static"
          show={showModalSelectTemplate}
          onHide={() => setShowModalSelectTemplate(false)}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => setShowModalSelectTemplate(false)}><RiCloseLine /></button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <div>
              <p>Select Template to { evtShowModalYesNo?.option === "retry" ? "Retry" : "Reprocess"}</p>
              {(templateOptions.length > 0) &&
                <select className="form-control form-control-md" id="selectTemplateDropDown" value={reprocTemplateName} onChange={(event) => {
                  setReprocTemplateName(event.target.value);
                }}>
                  {
                    !lobCodeValidationEnabled && !showCountryCodes ? templateOptions.map(templateOption => {
                      return <option key={templateOption.TemplatePath}>{templateOption.TemplateName}</option>;
                    }) :
                    templateOptions.map(templateOption => (
                      (templateOption.TemplateName.toUpperCase().startsWith(`${(documentObj && documentObj.document && documentObj.document.submissionIdentifier ? documentObj.document.submissionIdentifier.split('-')[0] : "RESERVED")}-`) || templateOption.TemplateName.toLowerCase() === 'default template') ?
                        (
                          showCountryCodes ? (
                            ((templateOption.TemplateName.toUpperCase().split("-")[1] === documentObj?.document?.submissionIdentifier?.toUpperCase().split('-')[1]) || (templateOption.TemplateName.toLowerCase() === 'default template')) ?
                              <option disabled={evtShowModalYesNo?.option !== "retry" && usedTemplates.findIndex(element => {
                                return element.toLowerCase() === templateOption.TemplateName.toLowerCase();
                              }) !== -1} key={templateOption.TemplatePath} className={evtShowModalYesNo?.option !== "retry" && usedTemplates.findIndex(element => {
                                  return element.toLowerCase() === templateOption.TemplateName.toLowerCase();
                                }) !== -1 ? 'option_disabled' : ''}>{templateOption.TemplateName}</option>
                              : null
                          )
                            : <option disabled={evtShowModalYesNo?.option !== "retry" && usedTemplates.findIndex(element => {
                              return element.toLowerCase() === templateOption.TemplateName.toLowerCase();
                            }) !== -1} key={templateOption.TemplatePath} className={evtShowModalYesNo?.option !== "retry" && usedTemplates.findIndex(element => {
                              return element.toLowerCase() === templateOption.TemplateName.toLowerCase();
                            }) !== -1 ? 'option_disabled' : ''}>{templateOption.TemplateName}</option>)
                        : <React.Fragment key="none"></React.Fragment>
                    ))
                  }
                </select>}
            </div>
            <button type="button" className="btn btn-primary btn-md font-weight-medium mt-3" onClick={async () => {
              if (reprocTemplateName.toLowerCase() === 'default template') {
                const subId = documentObj?.document?.submissionIdentifier?.split("-").map(part => part.toLowerCase()) || [];
                let isValidDefault = false;

                if (lobCodeValidationEnabled && !showCountryCodes) {
                  isValidDefault = templateOptions.some(t =>
                    t.TemplateName.toLowerCase() === `${subId[0]}-default template` ||
                    t.TemplateName.toLowerCase() === `${subId[0]}-defaulttemplate`
                  );
                } else if (lobCodeValidationEnabled && showCountryCodes) {
                  isValidDefault = templateOptions.some(t =>
                    t.TemplateName.toLowerCase() === `${subId[0]}-${subId[1]}-default template` ||
                    t.TemplateName.toLowerCase() === `${subId[0]}-${subId[1]}-defaulttemplate`
                  );
                }
                
                if (!isValidDefault) {
                  let errorMsg = '';
                  if (lobCodeValidationEnabled) {
                    if (showCountryCodes) {
                      errorMsg = `The default template associated with  ${subId[0]?.toUpperCase()}-${subId[1]?.toUpperCase()} could not be found. Please choose a valid template to proceed.`;
                    } else {
                      errorMsg = `The default template associated with ${subId[0]?.toUpperCase()} could not be found. Please choose a valid template to proceed.`;
                    }
                  }
                  setShowModalMsg(errorMsg);
                  setShowModal(true);
                  return;
                }
              }

              setEvtShowModalYesNo({ "params": { "row": documentObj.document }, "option": evtShowModalYesNo?.option });
              let msg = evtShowModalYesNo?.option === "retry" ? `You are about to resubmit the input document ${documentObj.document.documentName}. This will overwrite any previous contents created. Do you want to continue?` : `You are about to reprocess the submission[${documentObj.document.submissionIdentifier}] using the template [${reprocTemplateName}]. <b> Do you want to continue ? </b>`
              setShowModalYesNoMsg(msg);
              setShowModalYesNo(true);
            }} disabled={reprocTemplateName.trim().length === 0}>Submit</button>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        <Modal
          className="modal-md modal-primary"
          show={showMandatoryValidationModal}
          onHide={() => {
            setShowMandatoryValidationModal(false);
            validationResolveRef.current?.(false);
          }}
          backdrop="static"
          animation={false}
          backdropClassName="question-modal"
          centered
        >
          <Modal.Body className="text-center">
            <p className="multi-line d-block">
              {missingMandatoryFields.join(', ')} is not populated and is empty, do you want to continue?
            </p>
          </Modal.Body>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-secondary btn-md font-weight-medium"
              onClick={() => {
                validationResolveRef.current?.(false);
                setShowMandatoryValidationModal(false);
              }}
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-primary btn-md font-weight-medium"
              onClick={() => {
                validationResolveRef.current?.(true);
                setShowMandatoryValidationModal(false);
              }}
            >
              Yes
            </button>
          </div>
        </Modal>

        {/* Mini Modal */}
            <Modal
              className="modal-md modal-primary"
              show={showReviewModal}
              onHide={() => {
                setShowReviewModal(false);
                setShowReviewModalMsg([]);
              }}
              backdrop="static"
              animation={false}
              backdropClassName="question-modal"
            >
              <Modal.Header className="justify-content-center">
                <div className="modal-profile">
                  <i className="nc-icon nc-bulb-63"></i>
                </div>
              </Modal.Header>
              <Modal.Body className="text-center">
                    <Row>
                  <Col sm={12} className="mb-2">
                    {showReviewModalMsg[0]?.code === "error" && <h4>Warning</h4>}
                  </Col>
                  <Col sm={12} className="modal-list d-flex justify-content-center">
                    <span>
                      {
                        showReviewModalMsg.map(msgInfo => (
                          <p>{msgInfo.msg}</p>
                        ))
                      }
                    </span>
                  </Col>
                </Row>
              </Modal.Body>
              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-secondary btn-md font-weight-medium yesBtn"
                  onClick={() => {
                    setShowModalCompleteOrReject(false);
                    setTabSelected("home"); 
                    setIsInUploadedStatus(false);
                    setSelectedDateFormat('');
                    setInputDateFormats([]);
                    setShowReviewModal(false);
                    setShowReviewModalMsg([]);
                    setThresholdValidation(false)
                  }}
                >
                  Review
                </button>
                <button type="button" className="btn btn-primary btn-md font-weight-medium"
                  onClick={async (e) => {
                    var s3Path;
                    e.preventDefault();
                    setLoading(true);
                    setShowModalCompleteOrReject(false);
                    setShowReviewModal(false);
                    setShowReviewModalMsg([]);
                    setRejectionReasons('');
                    setShowModalMsg("");
                    setShowModal(false);
                    var resp = await fetchDocStatus(documentObj);
                    let validateTemplate;
                    let validateEntityMatch;
                    let xlType;
                    var fetchDoc = await getDocDetailsList(documentObj.document);
                    let getInstanceDetails = { instanceRegion: instanceDetails.InstanceRegion, instanceBucket: instanceDetails.InstanceBucket};
                    const getTransformData = await fetchTransformationJSONData(fetchDoc, getInstanceDetails);
                    if (getTransformData === false) {
                        xlType = "Generic"
                    } else {
                        xlType = getTransformData.inputFileType
                    }

                    if (resp && resp?.processingStatus !== "In Progress") {
                      setShowModalMsg("This submission is already processed, refresh the list to see the latest status");
                      setShowModal(true);
                      setLoading(false);
                    } else {
                      resp = {};
                      setLoading(true);
                      const user = await Auth.currentAuthenticatedUser({
                        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
                      });
                      if ((enableUserDataValidations === true && runValidations === false) || (formData.uploadDocumentName.toLowerCase().endsWith(".csv"))) {
                        s3Path = `${getExtractPath(documentObj.document.documentFullPath !== null ? documentObj.document.documentFullPath : documentObj.document.uploadDocumentFullPath)}/${uuid()}-${formData.uploadDocumentName}`;
                        await Storage.put(s3Path, formData.file, {
                          metadata: { transmitToClient: "true" }
                        });
                        validateTemplate = xlType === "Generic" ? await validateGenericTemplate(documentObj.document, s3Path) : false;
                        if(validateTemplate === true){
                          let templateRules = await getTemplateRules(documentObj.document.templateName);
                          if (typeof templateRules?.metaData?.validateOnMarkComplete === "undefined") {
                            const defaultRules = await fetchJSONFromS3("templates/rules/default_rules.json");
                            templateRules =  defaultRules || {};
                          }
                          if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true || templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                            const templateJsonData = await getTemplateJson(documentObj.document, instanceDetails?.instanceRegion, instanceDetails.instanceBucket);
                            const jsonData = await extractExcelData(s3Path, instanceDetails?.instanceRegion, instanceDetails?.instanceBucket);
                            if (xlType === "Generic" && templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                              const meaTemplateValidation = validateMeaTemplateName(jsonData, documentObj.document?.templateName);
                              if (!meaTemplateValidation?.valid) {
                                setShowModalMsg(meaTemplateValidation?.error || "meaTemplateName validation failed.");
                                setShowModal(true);
                                setLoading(false);
                                return;
                              }
                            }
                            if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true) {
                              validateEntityMatch = xlType === "Generic" ? doEntityNamesMatch(jsonData, templateJsonData): true;
                              if (!validateEntityMatch) {
                                setShowEntitiesMismatchModal(true);
                                setLoading(false);
                                return;
                              }
                            }
                          }
                        }
                        resp = await runMacros(user.username, user.attributes.email, documentObj.document, s3Path, user.signInUserSession.idToken.jwtToken, false, formData.uploadDocumentName);
                        await doUxDocumentProcessing(documentObj.document, "Complete", "Document marked complete", undefined, s3Path);
                        await updateTransformedPathForFinish(documentObj.document);
                        if (resp.status === true) {
                          await submissionDataLake(documentObj.document, user.attributes.email, s3Path);
                        }
                      } else {
                        try {
                          s3Path = `${getExtractPath(documentObj.document.documentFullPath !== null ? documentObj.document.documentFullPath : documentObj.document.uploadDocumentFullPath)}/${uuid()}-${formData.uploadDocumentName}`;
                          await Storage.put(s3Path, formData.file, {
                            metadata: { transmitToClient: "true" }
                          });
                          validateTemplate = xlType === "Generic" ? await validateGenericTemplate(documentObj.document, s3Path) : false;
                          if(validateTemplate === true){
                            let templateRules = await getTemplateRules(documentObj.document.templateName);
                            if (typeof templateRules?.metaData?.validateOnMarkComplete === "undefined") {
                              const defaultRules = await fetchJSONFromS3("templates/rules/default_rules.json");
                              templateRules =  defaultRules || {};
                            }
                            if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true || templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                              const templateJsonData = await getTemplateJson(documentObj.document, instanceDetails?.instanceRegion, instanceDetails.instanceBucket);
                              const jsonData = await extractExcelData(s3Path, instanceDetails?.instanceRegion, instanceDetails?.instanceBucket);
                              if (xlType === "Generic" && templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                                const meaTemplateValidation = validateMeaTemplateName(jsonData, documentObj.document?.templateName);
                                if (!meaTemplateValidation?.valid) {
                                  setShowModalMsg(meaTemplateValidation?.error || "meaTemplateName validation failed.");
                                  setShowModal(true);
                                  setLoading(false);
                                  return;
                                }
                              }
                              if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true) {
                                validateEntityMatch = xlType === "Generic" ? doEntityNamesMatch(jsonData, templateJsonData) : true;
                                if (!validateEntityMatch) {
                                  setShowEntitiesMismatchModal(true);
                                  setLoading(false);
                                  return;
                                }
                              }
                            }
                          }
                          resp = await runMacros(user.username, user.attributes.email, documentObj.document, s3Path, user.signInUserSession.idToken.jwtToken, undefined,formData.uploadDocumentName, thresholdValidation);
                          if (resp.status === true) {
                            await submissionDataLake(documentObj.document, user.attributes.email, s3Path);
                          }
                        } catch (err) {
                          console.error('err: ', err);
                        } finally {
                          setLoading(false);
                        }
                        e.target.value = null;
                        if (resp.msg !== undefined && resp.msg.length > 0) {
                          setShowModalListMsg(resp.msg);
                          setShowModalList(true);
                        } else if(validateEntityMatch === true){
                          setShowModalList(true);
                        }
                      }
                    }
                    setSelectedDateFormat('');
                    setInputDateFormats([]);
                    setXlType("Generic");
                    await fetchDocuments(true, undefined, undefined, undefined, isArchived);
                    setThresholdValidation(false);
                    setFormData(initialFormState);
                    setLoading(false);
                  }}
                >Continue</button>
              </div>
            </Modal>
            {/* End Modal */}

        {/* Mini Modal */}
        <Modal
          className={`modal-md modal-primary new-modal${evtShowModalYesNo?.option === "disable-run-validations" ? " run-validations-warning-modal" : ""}`}
          backdrop="static"
          show={showModalYesNo}
          onHide={() => setShowModalYesNo(false)}
          animation={false}
          backdropClassName="question-modal"
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => {
              setShowModalYesNo(false);
              if (evtShowModalYesNo.option === "upload-docs") {
                evtShowModalYesNo.params.target.value = null;
              }
              setEvtShowModalYesNo(null);
            }}><RiCloseLine />
            </button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <p className="multi-line">{renderReactFragment(showModalYesNoMsg)}</p>
            {evtShowModalYesNo?.option === "disable-run-validations" && (
              <button type="button" className="btn btn-secondary btn-md font-weight-medium mr-2" onClick={() => {
                setShowModalYesNo(false);
                setEvtShowModalYesNo(null);
              }}>No</button>
            )}
            <button type="button btn-primary" className="btn btn-primary btn-md font-weight-medium" id="mark-complete-yes-btn" onClick={async () => {
              if (evtShowModalYesNo.option === "upload-docs") {
                setNewDocumentForUpload(evtShowModalYesNo.params, true);
              } else if (evtShowModalYesNo.option === "start-qa") {
                evtShowModalYesNo.params.evt.preventDefault();
                doUxDocumentProcessing(evtShowModalYesNo.params.row, "QA In Progress", "Document marked as QA In Progress");
              } else if (evtShowModalYesNo.option === "complete-qa") {
                evtShowModalYesNo.params.evt.preventDefault();
                doUxDocumentProcessing(evtShowModalYesNo.params.row, "QA Complete", "Document marked as QA Complete");
              } else if (evtShowModalYesNo.option === "reprocess") {
                evtShowModalYesNo.params.evt.preventDefault();
                var document = evtShowModalYesNo.params.row;
                logAudit(document.document_id, document.submissionIdentifier, "Submission", "Reprocess", "UI", undefined, undefined).then((data) => { });
                doUxDocumentProcessing(evtShowModalYesNo.params.row, "In Progress", "Document marked as under processing");
              } else if (evtShowModalYesNo.option === "retry") {
                retryDocument(evtShowModalYesNo.params.row, reprocTemplateName);
              } else if (evtShowModalYesNo.option === "delete") {
                removeDocument(evtShowModalYesNo.params.evt, evtShowModalYesNo.params.row);
              } else if (evtShowModalYesNo.option === "reproc-template") {
                reprocessDocument(evtShowModalYesNo.params.row, reprocTemplateName);
              } else if (evtShowModalYesNo.option === "disable-run-validations") {
                setRunValidations(false);
              }
              setShowModalYesNo(false);
            }}>Yes</button>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        {/* Mini Modal */}
        <Modal
          className="modal-centre submissions-finish new-modal"
          backdrop="static"
          show={showModalCompleteOrReject}
          onHide={() => {
            setShowModalCompleteOrReject(false);
            setSelectedDateFormat('');
            setInputDateFormats([]);
            setXlType("Generic");
          }}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => {
              setShowModalCompleteOrReject(false);
              setTabSelected("home");
              setIsInUploadedStatus(false);
            }}><RiCloseLine />
            </button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <Tabs defaultActiveKey={tabSelected} id="finish-processing" className="mb-3">
              <Tab eventKey="home" title="Finish Processing" disabled={isInUploadedStatus}>
                <Form.Group className="mb-0">
                  <Card className="strpied-tabled-with-hover mb-0">
                    <Card.Body className="table-responsive">
                      <Row>
                        <Col className="d-flex justify-content-center" md="12">
                          <Form.Group className="mb-2">
                            <h5 className="mb-3">File to upload</h5>
                            <Form.Control
                              placeholder="Select File"
                              type="file"
                              id="mark-complete-file-input"
                              accept={mcUploadExt}
                              onChange={(e) => {
                                onChange(e, true);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      {enableUserDataValidations && <Row>
                        <Col className="text-center modal-checkbox" md="12">
                          <div className="form-group mb-2">
                            <div className="input-group">
                              <input type="checkbox" id="run-validation-checkbox" className="form-control border-left-0" onChange={() => {
                                if (runValidations) {
                                  setEvtShowModalYesNo({ option: "disable-run-validations" });
                                  setShowModalYesNoMsg("Disabling Run Validations will skip validation and post-processing for this submission, which can result in empty or ignored data. Do you want to continue?");
                                  setShowModalYesNo(true);
                                } else {
                                  setRunValidations(true);
                                }
                              }} checked={runValidations} />
                            </div>
                            <label>Run Validations</label>
                          </div>
                        </Col>
                      </Row>}
                      <Row>
                        <div className="col-12 radio-btns">
                          <input type="radio" value="Green" name="green" onChange={() => {
                            if (triageLane !== "Green") {
                              setTriageLane("Green");
                              setDeclineCode([]);
                            }
                          }} checked={triageLane === "Green"} /> <label>Green</label>
                          <input type="radio" value="Amber" name="amber" onChange={() => {
                            if (triageLane !== "Amber") {
                              setTriageLane("Amber");
                              setDeclineCode([]);
                            }
                          }} checked={triageLane === "Amber"} /> <label>Amber</label>
                          <input type="radio" value="Red" name="red"
                            onChange={() => {
                              if (triageLane !== "Red") {
                                setTriageLane("Red");
                                setDeclineCode([]);
                              }
                            }} checked={triageLane === "Red"} /> <label>Red</label>
                        </div>
                      </Row>
                      {enableTriage && (triageLane !== "Green") && <Row className="d-flex justify-content-center mb-3">
                        <Col className="text-center modal-checkbox" lg="12">
                          <MultiSelect
                            onChange={onDeclineCodesChange}
                            options={declineCodeOptions}
                          />
                        </Col>
                      </Row>}
                      {inputDateFormats?.length > 0 && (xlType?.toLowerCase() === 'sov' || xlType?.toLowerCase() === 'loss run') && <Row>
                        <Col xs lg="12">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-12 pl-1 pr-1 mx-auto py-2">
                            <label>Input Date format</label>
                            <select
                              className="form-select form-control"
                              value={selectedDateFormat}
                              onChange={(event) => {
                                setSelectedDateFormat(event.target.value);
                              }}
                            >
                              {[
                                { value: "", label: "Select Date Format" }, // Default option
                                ...inputDateFormats
                              ].map((format) => (
                                <option key={format.value} value={format.value}>
                                  {format.label}
                                </option>
                              ))}
                            </select>
                          </div>

                        </Col>
                      </Row>}
                      <Row className="justify-content-center pb-2">
                        <Col className="col-lg-5 col-md-6 col-sm-6 col-6">
                          <button type="button" className="btn btn-primary btn-md font-weight-medium" id="mark-complete-btn" disabled={(!formData.uploadDocumentName || !formData.uploadDocumentFullPath || ((triageLane === "Red" || triageLane === "Amber") && declineCode.length === 0))} onClick={async (e) => {
                            var s3Path;
                            e.preventDefault();
                            setLoading(true);
                            setShowModalCompleteOrReject(false);
                            setRejectionReasons('');
                            setShowModalMsg("");
                            setShowModal(false);
                            var resp = await fetchDocStatus(documentObj);
                            let validateTemplate;
                            let validateEntityMatch, jsonData, templateJsonData;
                            let xlType;
                            var fetchDoc = await getDocDetailsList(documentObj.document);
                            let getInstanceDetails = { instanceRegion: instanceDetails.InstanceRegion, instanceBucket: instanceDetails.InstanceBucket};
                            const getTransformData = await fetchTransformationJSONData(fetchDoc, getInstanceDetails);
                            if (getTransformData === false) {
                                xlType = "Generic"
                            } else {
                                xlType = getTransformData.inputFileType
                            }

                            if (resp && resp?.processingStatus !== "In Progress") {
                              setShowModalMsg("This submission is already processed, refresh the list to see the latest status");
                              setShowModal(true);
                              setLoading(false);
                            } else {
                              resp = {};
                              setLoading(true);
                              const shouldContinue = await confirmMandatorySummaryFieldsForMarkComplete(
                                documentObj.document,
                                getTransformData,
                                xlType
                              );
                              if (!shouldContinue) {
                                setShowModalCompleteOrReject(true);
                                setLoading(false);
                                return;
                              }
                              const user = await Auth.currentAuthenticatedUser({
                                bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
                              });
                              if ((enableUserDataValidations === true && runValidations === false) || (formData.uploadDocumentName.toLowerCase().endsWith(".csv"))) {
                                s3Path = `${getExtractPath(documentObj.document.documentFullPath !== null ? documentObj.document.documentFullPath : documentObj.document.uploadDocumentFullPath)}/${uuid()}-${formData.uploadDocumentName}`;
                                await Storage.put(s3Path, formData.file, {
                                  metadata: { transmitToClient: "true" }
                                });
                                validateTemplate = xlType === "Generic" ? await validateGenericTemplate(documentObj.document, s3Path) : false;
                                if(validateTemplate === true){
                                  let templateRules = await getTemplateRules(documentObj.document.templateName);
                                  if (typeof templateRules?.metaData?.validateOnMarkComplete === "undefined") {
                                    const defaultRules = await fetchJSONFromS3("templates/rules/default_rules.json");
                                    templateRules =  defaultRules || {};
                                  }
                                  if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true || templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                                    const templateJsonData = await getTemplateJson(documentObj.document, instanceDetails?.instanceRegion, instanceDetails.instanceBucket);
                                    const jsonData = await extractExcelData(s3Path, instanceDetails?.instanceRegion, instanceDetails?.instanceBucket);
                                    if (xlType === "Generic" && templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                                      const meaTemplateValidation = validateMeaTemplateName(jsonData, documentObj.document?.templateName);
                                      if (!meaTemplateValidation?.valid) {
                                        setShowModalMsg(meaTemplateValidation?.error || "meaTemplateName validation failed.");
                                        setShowModal(true);
                                        setLoading(false);
                                        return;
                                      }
                                    }
                                    if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true) {
                                      validateEntityMatch = xlType === "Generic" ? doEntityNamesMatch(jsonData, templateJsonData): true;
                                      if (!validateEntityMatch) {
                                        setShowEntitiesMismatchModal(true);
                                        setLoading(false);
                                        return;
                                      }
                                    }
                                  }
                                }
                                resp = await runMacros(user.username, user.attributes.email, documentObj.document, s3Path, user.signInUserSession.idToken.jwtToken, false, formData.uploadDocumentName);
                                await doUxDocumentProcessing(documentObj.document, "Complete", "Document marked complete", undefined, s3Path);
                                await updateTransformedPathForFinish(documentObj.document);
                                if (resp.status === true) {
                                  await submissionDataLake(documentObj.document, user.attributes.email, s3Path);
                                }
                              } else {
                                try {
                                  s3Path = `${getExtractPath(documentObj.document.documentFullPath !== null ? documentObj.document.documentFullPath : documentObj.document.uploadDocumentFullPath)}/${uuid()}-${formData.uploadDocumentName}`;
                                  await Storage.put(s3Path, formData.file, {
                                    metadata: { transmitToClient: "true" }
                                  });
                                  validateTemplate = xlType === "Generic" ? await validateGenericTemplate(documentObj.document, s3Path) : false;
                                  if(validateTemplate === true){
                                    let templateRules = await getTemplateRules(documentObj.document.templateName);
                                    if (typeof templateRules?.metaData?.validateOnMarkComplete === "undefined") {
                                      const defaultRules = await fetchJSONFromS3("templates/rules/default_rules.json");
                                      templateRules =  defaultRules || {};
                                    }
                                    if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true || templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                                      const templateJsonData = await getTemplateJson(documentObj.document, instanceDetails?.instanceRegion, instanceDetails.instanceBucket);
                                      const jsonData = await extractExcelData(s3Path, instanceDetails?.instanceRegion, instanceDetails?.instanceBucket);
                                      if (xlType === "Generic" && templateRules?.metaData?.validateOnMarkComplete?.validateMeaTemplateName === true) {
                                        const meaTemplateValidation = validateMeaTemplateName(jsonData, documentObj.document?.templateName);
                                        if (!meaTemplateValidation?.valid) {
                                          setShowModalMsg(meaTemplateValidation?.error || "meaTemplateName validation failed.");
                                          setShowModal(true);
                                          setLoading(false);
                                          return;
                                        }
                                      }
                                      if (templateRules?.metaData?.validateOnMarkComplete?.validateTemplateEntities === true) {
                                        validateEntityMatch = xlType === "Generic" ? doEntityNamesMatch(jsonData, templateJsonData): true;
                                        if (!validateEntityMatch) {
                                          setShowEntitiesMismatchModal(true);
                                          setLoading(false);
                                          return;
                                        }
                                      }
                                    }
                                  }
                                  resp = await runMacros(user.username, user.attributes.email, documentObj.document, s3Path, user.signInUserSession.idToken.jwtToken, undefined, formData.uploadDocumentName, thresholdValidation);
                                  if (resp.status === true) {
                                    await submissionDataLake(documentObj.document, user.attributes.email, s3Path);
                                  }
                                } catch (err) {
                                  console.error('err: ', err);
                                } finally {
                                  setLoading(false);
                                }
                                e.target.value = null;
                                if(resp.status === false && Array.isArray(resp?.msg) && resp.msg.some(msgInfo => msgInfo?.errorType === "thresholdNotMet")) {
                                  setShowReviewModalMsg(resp?.msg);
                                  setShowReviewModal(true);
                                  setThresholdValidation(true);
                                }
                                else if (resp.msg !== undefined && resp.msg.length > 0) {
                                  setShowModalListMsg(resp.msg);
                                  setShowModalList(true);
                                } else if(validateEntityMatch === true){
                                  setShowModalList(true);
                                }
                              }
                            }
                            setSelectedDateFormat('');
                            setInputDateFormats([]);
                            setXlType("Generic");
                            await fetchDocuments(true, undefined, undefined, undefined, isArchived);
                            setLoading(false);
                          }}>Mark complete</button>
                        </Col>
                        <Col className="col-lg-3 col-md-3 col-sm-4 col-4">
                          <button type="button" className="btn btn-primary btn-md font-weight-medium" onClick={() => { setShowModalCompleteOrReject(false); setTabSelected("home"); setIsInUploadedStatus(false); setSelectedDateFormat(''); setInputDateFormats([]); }}>Cancel</button>
                        </Col>
                      </Row>
                      <hr></hr>
                      <div className="stats mt-2">
                        Upload processed document to complete submission
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              </Tab>
              <Tab eventKey="profile" title="Reject" id="rejectTab">
                <Form.Group className="mb-0">
                  <Card className="strpied-tabled-with-hover mb-0">
                    <Card.Body className="table-responsive">
                      <Form.Group>
                        <label>Rejection Reasons</label>
                        <div className="px-0">
                          <select defaultValue="" className="form-control form-control-md" id="rejectionReasonDropdown" value={rejectionReasons} onChange={(event) => {
                            setCurrentData([]);
                            setRejectionReasons(event.target.value);
                          }}>
                            {
                              ["Select", ...rejectionReasonsList].map((reasons, idx) => idx === 0 ? (<option key="none" value="">{reasons}</option>) : (
                                <option key={reasons} value={reasons}>{reasons}</option>
                              ))
                            }
                          </select>
                        </div>
                      </Form.Group>
                      <Row className="justify-content-center mt-3">
                        <Col sm="12">
                          <button type="button" id="rejectFileBtn" className="btn btn-primary btn-md font-weight-medium mr-1"
                            disabled={!rejectionReasons ? true : false}
                            onClick={async (e) => {
                              e.preventDefault();
                              setLoading(true);
                              var resp = await fetchDocStatus(documentObj);
                              var origInfo = await fetchDocument(resp?.origin_document_id);
                              if (resp && resp?.processingStatus !== "In Progress" && !isInUploadedStatus) {
                                setShowModalMsg("This submission is already processed, refresh the list to see the latest status");
                                setShowModal(true);
                                setLoading(false);
                              } else {
                                if (rejectionReasons.trim().length === 0) {
                                  setShowModalMsg("You need to select rejection reasons");
                                  setShowModal(true);
                                  return;
                                }
                                doUxDocumentProcessing(documentObj.document, "Rejected", "Document marked rejected", rejectionReasons, undefined, undefined, undefined, undefined, undefined, origInfo?.source === "mailbox" ? origInfo?.metaInfo : undefined);
                                setRejectionReasons("");
                                setTabSelected("home");
                                setIsInUploadedStatus(false);
                              }
                              setSelectedDateFormat('');
                              setInputDateFormats([]);
                              setXlType("Generic");
                            }}>Reject file</button>
                          <button type="button" className="btn btn-primary btn-md font-weight-medium ml-1" onClick={() => {
                            setShowModalCompleteOrReject(false);
                            setRejectionReasons("");
                            setTabSelected("home");
                            setIsInUploadedStatus(false);
                            setSelectedDateFormat('');
                            setInputDateFormats([]);
                            setXlType("Generic");
                          }}>Cancel</button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Form.Group>
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        {/* Mini Modal */}

        <Modal
          className="modal-md modal-primary viewmapping-modal"
          show={showEntitiesMismatchModal}
          onHide={() => setShowEntitiesMismatchModal(false)}
          backdrop="static"
          animation={false}
          backdropClassName="question-modal"
          size="xl"
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => {
              setShowEntitiesMismatchModal(false);
            }}>
              <RiCloseLine />
            </button>
          </Modal.Header>
          {/* <div className="extractdraggable-modal"> */}
          <Modal.Body>
            <span style={{ color: "red"}}>
              Error: The entity names in the extracted file do not match the submission template. Please check.
            </span>
          </Modal.Body>
            <div className="table-responsive">
              <Table bordered className="p-4">
                <thead>
                  <tr>
                    <th className="font-weight-bolder w-40 text-black">Template Entity Names</th>
                    <th className="font-weight-bolder w-40 text-black">Extraction file Entity Names</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {Array.from({ length: Math.max(templateEntityNamesData.length, jsonEntityNamesData.length) }).map((_, idx) => (
                    <tr key={idx}>
                      <td>{templateEntityNamesData[idx] || ""}</td>
                      <td>{jsonEntityNamesData[idx] || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
          {/* </div> */}
        </Modal>
        {/* End Modal */}


        {/* Mini Modal */}
        <Modal
          className="modal-centre new-modal"
          backdrop="static"
          show={showManualMerge}
          onHide={() => setShowManualMerge(false)}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => setShowManualMerge(false)}><RiCloseLine /></button>
          </Modal.Header>
          <Modal.Body className="text-center manual-merge pt-0">
            <Tabs defaultActiveKey="home" id="manual-processing" className="mb-3">
              <Tab eventKey="home" title="Manual Merge">
                <Form.Group className="mb-0">
                  <Card className="strpied-tabled-with-hover mb-0">
                    <Card.Body className="table-responsive">
                      <Row>
                        <Col className="justify-content-center mb-3" lg="12">
                          <Form.Group>
                            <h5 className="mb-3">File to upload</h5>
                            <Form.Control
                              placeholder="Select File"
                              type="file"
                              accept=".pdf"
                              onChange={(e) => {
                                onMergeFileChange(e);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="justify-content-center mb-3">
                        <Col className="col-12">
                          <button type="button" className="btn btn-primary btn-md font-weight-medium mr-1" disabled={formData.file === null} onClick={(e) => {
                            uploadManualMergeDoc(e, documentObj.document);
                          }}>Manual Merge</button>
                          <button type="button" className="btn btn-primary btn-md font-weight-medium ml-1" onClick={() => setShowManualMerge(false)}>Cancel</button>
                        </Col>
                      </Row>
                      <hr></hr>
                      <div className="stats">
                        Upload manual merged document
                      </div>
                    </Card.Body>
                  </Card>
                </Form.Group>
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        {/* Mini Modal */}
        <Modal
          className="modal-centre new-modal"
          backdrop="static"
          show={checkout}
          onHide={() => setCheckout(false)}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={() => setCheckout(false)}><RiCloseLine /></button>
          </Modal.Header>
          <Modal.Body className="text-center pt-0">
            <Form.Group>
              <Card className="strpied-tabled-with-hover">
                <Card.Body className="table-responsive">
                  <Form.Group>
                    <label>Finish Payment</label>
                    <div className="payment-div">
                      <Suspense fallback={<CirclesLoader isLoading={loading} />}>
                        <ReactPayPal document={documentObj.document} fetchDocuments={fetchDocuments} setPaid={setPaid} />
                      </Suspense>
                      <button type="button" className="btn btn-primary btn-md font-weight-medium" onClick={() => { setCheckout(false); }}>{paid
                        ? "Ok" : "Cancel"}</button>
                    </div>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}

        {/* Mini Modal */}
        <Modal
          className="modal-centre tags-modal new-modal"
          backdrop="static"
          show={showTagWindow}
          onHide={() => setShowTagWindow(false)}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
            <button className="closeicon" onClick={async () => {
              setShowTagWindow(false);
              setTagKey("");
              setTagValue("");
              setTagValueError("");
              await fetchTagsValues();
            }}><RiCloseLine />
            </button>
          </Modal.Header>
          <Modal.Body className="text-center pt-2">
            <Form.Group className="mb-0">
              <Card className="strpied-tabled-with-hover mb-0">
                <Card.Body className="table-responsive">
                  <label>Tags : {tagInput && tagInput.params && tagInput.params.row ? tagInput.params.row.submissionIdentifier : ""}[{tagInput && tagInput.params && tagInput.params.row ? tagInput.params.row.documentName : ""}] </label>
                  <ListGroup>
                    {tagInput && tagInput.params && tagInput.params.Tags && tagInput.params.Tags.map(item => (
                      <ListGroup.Item>
                        {item.key + " : " + item.value}
                        <button type="button" className="btn-action font-weight-medium" onClick={(e) => {
                          setTagsUpdated(true);
                          var tags = tagInput.params.Tags ? [...tagInput.params.Tags] : [];
                          for (var i = 0; i < tags.length; i++) {
                            if (tags[i].key === item.key) {
                              tags.splice(i, 1);
                              break;
                            }
                          }
                          setTagInput({ "params": { "row": tagInput.params.row, "Tags": tags } });
                        }}><i className="fa fa-trash" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Delete"></i></button>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                  <div className="payment-div">
                    <div onKeyUpCapture={() => {
                      const OriginalRegExp = window.RegExp;
                      window.RegExp = function SafeRegExp(pattern, flags) {
                        try {
                          return new OriginalRegExp(pattern, flags);
                        } catch (_) {
                          return new OriginalRegExp('(?!)', flags);
                        }
                      };
                      window.RegExp.prototype = OriginalRegExp.prototype;
                      requestAnimationFrame(() => { window.RegExp = OriginalRegExp; });
                    }}>
                    <MultiSelect
                      placeholder="Select Key"
                      className="mb-2"
                      defaultValue={tagKey}
                      customValue={true}
                      onChange={(selectedOption) => {
                        setTagValue("");
                        setSelectedTagData({});
                        setTagKey(selectedOption);
                        let selectedData = tagsList?.find(item => item.name === selectedOption);
                        if (selectedData) {
                          setSelectedTagData(selectedData);
                        } else {
                          let checkDuplicate = tagsList?.find(item => item?.name?.toString().toLowerCase() === selectedOption.toString().toLowerCase());
                          if (checkDuplicate === undefined) {
                            if (tagsList?.length === 0) {
                              setTagsList([{name: selectedOption, type: "default"}]);
                            } else {
                              setTagsList([...tagsList,{name: selectedOption, type: "default"}]); 
                            }
                            setSelectedTagData({name: selectedOption, type: "default"});
                          }                         
                        }
                      }}
                      options={
                        tagsList?.length > 0
                          ? tagsList.map(item => {
                            return { label: item?.name, value: item?.name };
                          })
                          : []
                      }
                      singleSelect={true}
                    />
                    </div>
                    {Object.entries(selectedTagData).length > 0 && (selectedTagData?.type?.toString().toLowerCase() !== "default" ? 
                    <div onKeyUpCapture={() => {
                      const OriginalRegExp = window.RegExp;
                      window.RegExp = function SafeRegExp(pattern, flags) {
                        try {
                          return new OriginalRegExp(pattern, flags);
                        } catch (_) {
                          return new OriginalRegExp('(?!)', flags);
                        }
                      };
                      window.RegExp.prototype = OriginalRegExp.prototype;
                      requestAnimationFrame(() => { window.RegExp = OriginalRegExp; });
                    }}>
                    <MultiSelect
                      placeholder="Select Value"
                      className="mb-2"
                      defaultValue={tagValue}
                      customValue={true}
                      onChange={(event) => {
                        let selectedData = Object.entries(selectedTagData).length > 0 && selectedTagData?.default_options?.find(item => item !== event);
                        if (selectedData) {
                          setTagValue(event);
                        } else if (selectedTagData.allow_custom === true && selectedData === undefined) {
                          let checkDuplicate = selectedTagData?.default_options?.find((item) => item.toString().toLowerCase() !== event.toString().toLowerCase());
                          if (checkDuplicate === undefined) {
                            setSelectedTagData(prevState => ({
                              ...prevState,
                              default_options: [...prevState.default_options, event],
                            }));
                          }
                        }
                      }}
                      options={
                        selectedTagData.default_options !== undefined &&
                        selectedTagData?.default_options.length > 0 && 
                        selectedTagData?.default_options.map(item => {
                          return { label: item, value: item }
                        })
                      }
                      singleSelect={selectedTagData.type.toString().toLowerCase() === "multi" ? false : true}
                    />
                    </div> : 
                    <>
                    <input 
                      type="text" 
                      className="form-control form-control-md mb-2" 
                      maxLength="10" 
                      placeholder="Enter Here" 
                      onChange={(event) => {
                        setTagValue(event.target.value);
                      }}
                      onBlur={() => {
                        if (isInvalidTagText(tagValue)) {
                          const invalidChars = getInvalidTagChars(tagValue);
                          setTagValueError(
                            invalidChars.length > 0
                              ? `Invalid character(s): ${invalidChars.map(c => `"${c}"`).join(', ')}`
                              : "Tag value must not be empty."
                          );
                        } else {
                          setTagValueError("");
                        }
                      }}
                      value={tagValue} 
                    />
                    {tagValueError && <div className="text-danger small mb-2">{tagValueError}</div>}
                    </>
                    )}
                    <button type="button" className="btn btn-primary btn-md font-weight-medium" onClick={() => {
                      if (isInvalidTagText(tagKey) || isInvalidTagText(tagValue)) {
                        const keyInvalid = getInvalidTagChars(tagKey);
                        const valInvalid = getInvalidTagChars(tagValue);
                        let msg = '';
                        if (keyInvalid.length > 0) msg += `Tag key has invalid character(s): ${keyInvalid.map(c => `"${c}"`).join(', ')}. `;
                        if (valInvalid.length > 0) msg += `Tag value has invalid character(s): ${valInvalid.map(c => `"${c}"`).join(', ')}.`;
                        if (!msg) msg = 'Tag key and value must not be empty.';
                        setShowModalMsg(msg.trim());
                        setShowModal(true);
                        return;
                      }
                      //not an existing tag?
                      var tags = tagInput.params.row.Tags ? [...tagInput.params.row.Tags] : [];
                      var existingKey = tags.filter(obj => {
                        return obj.key === tagKey
                      });
                      if (existingKey.length !== 0) {
                        setShowModalMsg(`Existing Tag ${tagKey}, delete first`);
                        setShowModal(true);
                      } else {
                        setTagsUpdated(true);
                        tags.unshift({ "key": tagKey.trim(), "value": tagValue.trim() });
                        setTagInput({ "params": { "row": tagInput.params.row, "Tags": tags } });
                      }
                      setTagKey("");
                      setTagValue("");
                      setTagValueError("");
                      //set in state
                    }}>Add Tag</button>
                    <button type="button" className="btn btn-primary btn-md font-weight-medium ml-2 mr-2" disabled={tagsUpdated === false} onClick={async () => {
                      const saved = await updateDocumentTags(tagInput.params.row.document_id, jsonToDb(tagInput.params.Tags));
                      if (!saved) {
                        return;
                      }
                      var added = [], removed = [];
                      if (tagInput.params.row.Tags !== null) {
                        tagInput.params.row.Tags.forEach(function (item) {
                          if (tagInput.params.Tags.indexOf(item) === -1) {
                            removed.push(item);
                          }
                        });
                      }
                      if (tagInput.params.row.Tags !== null) {
                        tagInput.params.Tags.forEach(function (item) {
                          if (tagInput.params.row.Tags.indexOf(item) === -1) {
                            added.push(item);
                          }
                        });
                      } else {
                        added = added.concat(tagInput.params.Tags);
                      }
                      var document = tagInput.params.row;
                      for (var i = 0; i < removed.length; i++) {
                        logAudit(document.document_id, document.submissionIdentifier, "Submission", "Deleted Tag", "UI", removed[i].key, removed[i].value).then((data) => { });
                      }
                      for (var m = 0; m < added.length; m++) {
                        logAudit(document.document_id, document.submissionIdentifier, "Submission", "Created Tag", "UI", added[m].key, added[m].value).then((data) => { });
                      }
                      tagInput.params.row.Tags = tagInput.params.Tags;
                      setTagsUpdated(false);
                      setShowTagWindow(false);
                    }}>Save</button>
                  </div>
                </Card.Body>
              </Card>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>
        {/* End Modal */}
        {/* submissionModal */}
        {(userRole === 'MEA_USERS' || userRole === 'MEA_CORPORATE' || userRole === 'MEA_ADMIN') &&
          <Modal
            className="block-example border border-dark new-modal"
            size="lg"
            show={submissionModal}
            centered={true}
            onHide={() => setSubmissionModal(false)}
            keyboard={false}
            backdrop="static"
          >
            <Modal.Header className="justify-content-end pt-3">
              <button className="closeicon" id="newSubmissionCloseBtn" onClick={() => {
                setSubmissionModal(false);
                setSubmissionIdentifier('');
                setSelectedFileName('');
                setEnableTemplate(false);
                setTemplateName([]);
                selectRef.current?.clearValue();
                setEnableSelectedTemplate(false);
              }}><RiCloseLine /></button>
            </Modal.Header>
            <Modal.Body className="pt-2">
              {disableUpload
                ? <Form.Group className="mb-0">
                  <label>File upload disabled</label>
                </Form.Group>
                : <Form.Group className="mb-0">
                  <Row>
                    <Col md="9" sm="12">
                      <input type="text" className="form-control form-control-md subid-fld" id="submissionIdentifierInput" placeholder={showClaims ? "Claim Identifier" : "Submission Identifier"} onChange={(event) => {
                        setSelectedGroup('');
                        setTemplateName([]);
                        setEnableSelectedTemplate(false);
                        selectRef.current?.clearValue();
                        setSubmissionIdentifier(event.target.value);
                      }} />
                      {getSubmissionIdentifierError(submissionIdentifier) && (
                        <div className="fs-12 text-danger mt-1" id="submissionIdentifierValidationError">
                          {getSubmissionIdentifierError(submissionIdentifier)}
                        </div>
                      )}
                      {submissionIdentifier !== '' && selectedFileName.length > 0 && <label htmlFor="submission-files-input" className="fs-12 mb-0"> {selectedFileName[0]?.name.length > 60
                        ? <><TiTick size={18} color={"#71c016"} /> <span data-bs-toggle="tooltip" data-bs-placement="bottom" title={selectedFileName[0]?.name}>{selectedFileName[0]?.name.split('.').slice(0, -1).join('.').slice(0, 60) + '....' + selectedFileName[0]?.name.split('.').pop()}</span></>
                        : <><TiTick size={18} color={"#71c016"} /> {selectedFileName[0]?.name}</>
                      }
                      </label>
                      }
                      {submissionIdentifier !== '' && selectedFileName.length > 1 && showFileNames()}
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Control
                        className="file-input__input btn btn-primary btn-md font-weight-medium"
                        placeholder="Select Files"
                        type="file"
                        id="submission-files-input"
                        accept={allowedExtensions}
                        multiple={(userRole === 'MEA_CORPORATE' || userRole === 'MEA_ADMIN')}
                        disabled={isInvalidSubmissionId(submissionIdentifier)}
                        size="md"
                        onChange={(e) => {
                          selectRef.current?.clearValue();
                          setTemplateName([]);
                          setEnableSelectedTemplate(false);
                          onChange(e, false);
                        }}
                      ></Form.Control>
                      <div className="d-flex justify-content-end align-items-center">
                        <span><label disabled={isInvalidSubmissionId(submissionIdentifier)} className={"btn btn-primary btn-md font-weight-medium mb-0"} htmlFor="submission-files-input">Select Files</label></span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="9" sm="9">
                      {enableTemplate && (templateOptions?.length > 0) &&
                        <Row>
                          <Col lg="3" md="4" sm="4" className="mt-4 pr-0">
                            <h5>Select a Template</h5>
                          </Col>
                          <Col lg="9" md="8" sm="8" className="mt-3 pl-1">
                            <Select className="selectTemplate multi-template" id="selectaTemplate" 
                              ref={selectRef}
                              isMulti={Array.from(selectedFileName)?.every(file =>
                                !['.zip'].some(ext => file.name.endsWith(ext))
                              )}
                              isSearchable={false}
                              closeMenuOnSelect={false} 
                              onChange={(event) => {
                                if (event !== null && Array.isArray(event)) {
                                    setTemplateName(event);
                                } else if (event !== null && typeof event === 'object') {
                                  setTemplateName([event]);
                                }
                                if(event === null || event.length === 0) {
                                  setEnableSelectedTemplate(false);
                                } else {
                                  setEnableSelectedTemplate(true);
                                }
                              }}
                              hideSelectedOptions={false}
                              options={
                                mapTemplateOptions().filter(template => template.Status !== "InProgress").map((template) =>{ 
                                  return ( 
                                    { value: template.TemplateName, label: template.TemplateName }
                                  )}
                              )}
                              components={{
                                ValueContainer,
                                Option: ({ children, isSelected, ...props }) => {
                                  return (
                                    <ReactSelectComponents.Option {...props} isSelected={isSelected}>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <span>{children}</span>
                                        {isSelected ? <span className="check_icon"><i className="fas fa-check"></i></span> : null}
                                      </div>
                                    </ReactSelectComponents.Option>
                                  );
                                }
                              }}
                            />
                          </Col>
                        </Row>
                      }
                      {enableTemplate && !(filteredUserGroups()?.length === 1 && (filteredUserGroups()?.map((group, index) => group?.GroupName)[0].toLowerCase() === "default")) && (
                        <Row>
                          <Col md="3" sm="4" className="mt-4 pr-0">
                            <h5>Select a Group</h5>
                          </Col>
                          <Col md="9" sm="8" className="mt-3 pl-1">
                            <select
                              className="form-control form-control-md selectGroup"
                              id="selectaGroup"
                              value={selectedGroup}
                              onChange={(event) => setSelectedGroup(event.target.value)}
                            >
                              {filteredUserGroups().map((group, index) => (
                                <option key={index} value={group.group_id}>{group.GroupName}</option>
                              ))}
                            </select>
                          </Col>
                        </Row>
                      )}
                    </Col>
                    <Col md="3" sm="3" className="mt-3 text-right btn-search-refresh btn-upload-submission">
                      {disableUpload
                        ? <button type="button" className="btn btn-primary btn-md font-weight-medium" >Upload Disabled</button>
                        : <button type="button" id="upload-submission-btn" className="btn btn-primary btn-md btn-reduce" disabled={(isInvalidSubmissionId(submissionIdentifier)) || disallowSubmission(formData.file, formData.files) || filteredUserGroups().length === 0 || !enableSelectedTemplate} onClick={createDocuments}>Upload Files</button>
                      }
                    </Col>
                  </Row>
                  {/* } */}
                </Form.Group>
              }
            </Modal.Body>
            <Modal.Footer className="justify-content-center pb-0">
              <p>powered by <span>mea platform</span></p>
            </Modal.Footer>
          </Modal>
        }
        {/* Mini Modal */}
        {!loading && <Modal
          className="modal-mini modal-primary new-modal"
          backdrop="static"
          keyboard={false}
          show={showTourModal}
          animation={false}
          centered={true}
        >
          <Modal.Header className="justify-content-end pt-3">
          <button className="closeicon" onClick={() => {
              setShowTourModal(false);
              localStorage.removeItem("lastAccessed");
            }}
            ><RiCloseLine /></button>
          </Modal.Header>
          <Modal.Body className="pt-0 text-center">
            {showTourModal && <div>
              <button className="btn btn-primary btn-tour pt-0" onClick={(event) => {
                event.preventDefault();
                setTourNewSubmissionVisible(true);
                setSteps(steps["submissions"]);
                setCurrentStep(0);
                setIsOpen(true);
                setShowTourModal(false);
                localStorage.removeItem("lastAccessed");
              }}>
                <RiPlayCircleLine className="d-block text-center icon-play" />
                Start Turn On Tour
              </button>
            </div>
            }
          </Modal.Body>
          <Modal.Footer className="justify-content-center pb-0">
            <p>powered by <span>mea platform</span></p>
          </Modal.Footer>
        </Modal>}
        {/* End Modal */}

        {/* Static New Submission Modal for data tour */}
        {tourNewSubmissionVisible && (currentStep === 1 || currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5) &&
          <div className="newsubmission-static">
            <div className="block-example">
              <div className="d-block pt-1 pl-2 pr-2">
                <div className="d-flex justify-content-end">
                  <span
                    aria-hidden="true"
                    title="Close"
                    className="hover-cursor">
                    ×
                  </span>
                  <span className="sr-only">Close</span>
                </div>
              </div>
              <div className="pt-2">
                {disableUpload
                  ? <Form.Group className="mb-0">
                    <label>File upload disabled</label>
                  </Form.Group>
                  :
                  <Form.Group className="mb-0">
                    <Row>
                      <Col md="9" sm="12" data-tour="step-2">
                        <input type="text" className="form-control form-control-md subid-fld" id="submissionIdentifierInput" placeholder={`${showClaims ? "claim Identifier" : "submission Identifier"}`} disabled />
                      </Col>
                      <Col md="3" sm="12">
                        <Form.Control
                          className="file-input__input btn btn-primary btn-md font-weight-medium"
                          placeholder="Select Files"
                        ></Form.Control>
                        <div className="d-flex justify-content-end align-items-center">
                          <span><label disabled className={"btn btn-primary btn-md font-weight-medium mb-0"} data-tour="step-3">Select Files</label></span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="9" sm="9">
                        <Row data-tour="step-4">
                          <Col lg="3" md="4" sm="4" className="mt-4 pr-0">
                            <h5>Select a Template</h5>
                          </Col>
                          <Col lg="9" md="8" sm="8" className="mt-3 pl-1">
                            <select className="form-control form-control-md selectTemplate" disabled>
                              <option>Default Template</option>
                            </select>
                          </Col>
                        </Row>
                        <Row data-tour="step-5">
                        <Col md="3" sm="4" className="mt-4 pr-0">
                          <h5>Select a Group</h5>
                        </Col>
                        <Col md="9" sm="8" className="mt-3 pl-1">
                          <select className="form-control form-control-md selectTemplate" disabled>
                            <option>Default</option>
                          </select>
                        </Col>
                        </Row>
                      </Col>
                      <Col md="3" sm="3" className="mt-3 text-right btn-search-refresh btn-upload-submission">
                        <button type="button" className="btn btn-primary btn-md btn-reduce" disabled data-tour="step-6">Upload Files</button>
                      </Col>
                    </Row>
                  </Form.Group>
                }
              </div>
            </div>
          </div>
        }
        <Suspense fallback={<div>Loading...</div>}>
          {!documentObj.document?.archivedQa && <QATool document={documentObj.document} launchQATool={launchQATool} setLaunchQATool={setLaunchQATool} fetchDocuments={fetchDocuments} qaToolDocs={qaToolDocs} setLoading={setLoading} templateControllerList={templateControllerList} isArchived={isArchived} />}
        </Suspense>
        
        <Suspense fallback={<div>Loading...</div>}>
          <DiffViewer document={documentObj.document} launchDiffViewer={launchDiffViewer} setLaunchDiffViewer={setLaunchDiffViewer} setShowModal={setShowModal} setShowModalMsg={setShowModalMsg} setLoading={setLoading} getDocDetailsList={getDocDetailsList} />
        </Suspense>

        <Suspense fallback={<div>Loading...</div>}>
          {/* EXTRACTTOOL MARKER CODE START */}
          <ExtractTool
            fetchDocuments={fetchDocuments}
            platform={true}
            isArchived={Boolean(extractToolData?.archivedQa) || isArchived}
            userRole={userRole}
            extractToolData={extractToolData}
            setExtractToolData={setExtractToolData}
            getDocDetailsList={getDocDetailsList}
            doUxDocumentProcessing={doUxDocumentProcessing}
          />
          {/* EXTRACTTOOL MARKER CODE END */}
        </Suspense>
        
      </Container>
    </>
  );
}

export default SubmissionsList;
